/* eslint-disable no-useless-escape */
// i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector'; // 👈 이 부분을 추가합니다.


const resources = {
  en: {
    translation: {
      promptLogin: "Login is required.",
      shareLink: "Share Analysis",
      clipboardNotSupported: "This browser does not support the Clipboard API. Please copy the URL manually.",
      linkCopied:"Link successfully copied!",
      Insights:"Insights",
      portfolioList:"Portfolios",
      portfolioOptimizationTools:"Optimization",
      checkingTicker: "Looking up ticker...",
      showExpertMetrics: "Show More",
      hideExpertMetrics: "Hide",
      loadExampleDisclaimer:"The example stocks are arbitrarily selected and are not intended as investment advice or recommendations.",
      assetAllocationCalculator: "📊Asset Allocation",
      exampleHint: "New here? Try with example tickers!",
      loadExample: "Load Example Tickers",
      riskCalculation: "⚠️ Risk Simulation",
      discussion: "Discussion",
      footer: "The information provided on this website is for educational and entertainment purposes only and should not be considered financial advice. Consult with a qualified financial professional before making any investment decisions. | This site uses Google Analytics to analyze traffic and improve service. You can opt-out via your browser settings.",
      allocIntroMain:"Build your portfolio by simply entering a ticker code",
      allocIntroSub:"Add assets like stocks, bonds, gold, and crypto → Pick a strategy → Discover the optimal allocation!",
      slectAlloc: "Start",
      enterticker: "Enter Ticker Symbol",
      optimalallocation: "📌 Optimal Asset Allocation",
      backtestresult: "📊 Backtest Results",
      notValidTicker:  "Sorry, this ticker is not supported by our data provider.",
      dataLoadingCalculatiing: "📊 Data loading & calculating...",
      short: "Short",
      backtestPeriod: "📅 Backtest Period:",
      dobacktest: "📊 Run Backtest",
      year: "Year",
      selectAllocMethod: "Select Asset Allocation Strategy",
      minVarButtonDesc: "✅ Safe Investment",
      riskPartiyButtonDesc: "⚖️ Balanced Investment",
      blackLittermanButtonDesc: "🌍 Reflect Market Views",
      maxSharpeButtonDesc: "🚀 Maximize Expected Return",
      openExplanation: "Show Explanation",
      closeExplanation: "Close Explanation",
      dataperiod: "Data Period:",
      allowshort: "Allow Short Selling",
      AdvancedSetting: "Advanced Settings",

      riskfreerate: "Risk-Free Rate (%)",
      riskfreerateExplanation:
        "The risk-free rate represents the expected return from the safest possible investment without risk of losing principal. Typically, this is based on government bonds (e.g., US Treasury Bonds, Korean Government Bonds).",
      enterExpectedReturn: "Enter Your Expected Returns",
      enterExpectedReturnExplanationBL:
        "For any stocks without input, market-implied returns will be used.",
      enterExpectedReturnExplanationMaxSharpe:
        "If left blank, historical data will be used for the expected return.",
        enterExpectedReturnExample:"Example: 5%" ,
        warning1moreTicker: "📢 Please enter at least 1 ticker!",
      warningTooManyTicker: "⚠️ Entering too many tickers may slow down calculations.",
      DoassetAllocation: "📊 Run Optimal Asset Allocation",
      minVarExplanation:
        "This strategy minimizes overall portfolio risk. It focuses on assets with lower volatility to provide stable returns.",
      riskPartiyExplanation:
        "This approach allocates assets to ensure each asset contributes equally to overall portfolio risk. It prevents concentration in any single asset.",
      blackLittermanExplanation:
        "Optimizes the portfolio by incorporating market views. Allows balanced allocation, especially when investor opinions are added.",
      maxSharpeExplanation:
        "This strategy aims for the highest possible return relative to risk. It typically involves more volatile assets but offers higher expected returns in the long run.",
      indicator: "📌 Indicator",
      equalAllocation: "⚖️ Equal Allocation",
      optimizedPortfolio: "✅ Optimized Portfolio",
      Portfolio: "✅ Portfolio",
      benchmark: "📈 Benchmark",
    
      cumulativeReturn: "Cumulative Return",
      cagr: "CAGR",
      annualVolatility: "Annual Volatility",
      maxDrawdown: "Maximum Drawdown (MDD)",
      sharpeRatio: "Sharpe Ratio",
      calmarRatio: "Calmar Ratio",
      sortinoRatio: "Sortino Ratio",
    
      sharpePerformancetable: "Excess return relative to volatility.\n≥ 1.0 (Excellent)\n≤ 0.5 (Poor)",
      calmarPerformancetable: "Annual return relative to maximum drawdown.\n≥ 0.5 (Excellent)\n≤ 0.2 (Risky)",
      sortinoPerformancetable: "Return considering only downside risk.\n≥ 1.0 (Excellent)\n≤ 0.5 (Poor)",
      
      extendedDescriptions: {
        minVar: {
          title: "📌 What is the Minimum Variance Portfolio?",
          p1: "One of the most important goals in investing is to achieve returns while <bold>minimizing risk (volatility)</bold>.",
          p2: "The Minimum Variance Portfolio, derived from mean-variance optimization, is the portfolio with the <bold>lowest volatility</bold> and is suitable for investors seeking stable returns relative to risk.",
          visualTitle: "📊 Visual Explanation of the MVP",
          visualDesc: "The graph below shows the Minimum Variance Portfolio on the <bold>Efficient Frontier</bold>.",
          bullet1: "🔵 <bold>Blue curve</bold>: Efficient Frontier (the optimal relationship between risk and expected return for various asset allocation combinations)",
          bullet2: "🔴 <bold>Red dot</bold>: Minimum Variance Portfolio (the portfolio with the lowest volatility)",
          altImg: "Efficient Frontier graph",
          mathTitle: "📌 Mathematical Model of the Minimum Variance Portfolio",
          mathP1: "The expected return of the portfolio ",
          mathP2: " and the variance ",
          mathP3: " are defined as follows:",
          returnTitle: "① Portfolio Expected Return",
          varianceTitle: "② Portfolio Variance",
          objectiveTitle: "③ Objective Function for Optimal Weights",
          subjectTo: "subject to:"
        },
        riskParity: {
          title: "📌 What is Risk Parity?",
          p1: "The risk parity strategy allocates assets so that <bold>each asset contributes equally to the overall risk of the portfolio</bold>.",
          p2: "In particular, it aims to construct a more stable portfolio by <bold>increasing the weight of low-volatility assets and reducing the weight of high-volatility assets</bold>.",
          conceptTitle: "📌 Core Concepts of Risk Parity",
          bullet1: "✅ <bold>Equal adjustment of each asset's risk contribution</bold>",
          bullet2: "✅ <bold>Reducing the weight of high-volatility assets and increasing that of low-volatility ones</bold>",
          bullet3: "✅ Constructing the portfolio without estimating expected returns makes it <bold>less prone to forecast errors</bold>",
          mathTitle: "📌 Overview of the Mathematical Model",
          rcTitle: "① Risk Contribution of Each Asset",
          rcP1: "The risk contribution of asset ",
          rcP2: " (",
          rcP3: ") is defined as follows:",
          rcP4: "Here, ",
          rcP5: " is the absolute contribution to the portfolio's total volatility. It is normalized by the portfolio's total volatility ",
          rcP6: " to express it as a ratio.",
          rcP7: "The list below explains the meaning of each term:",
          rcList1: "The portfolio weight of asset i",
          rcList2: "The covariance matrix of the assets",
          rcList3: "The contribution of asset i to the portfolio's volatility",
          rcList4: "The total portfolio volatility (σₚ = √(wᵀΣw))",
          conditionTitle: "② Risk Parity Condition",
          conditionP1: "It is optimized so that all assets contribute equally to risk.",
          conditionP2: "In other words, expressed as a ratio:",
          optimalTitle: "③ Optimal Portfolio Weights",
          optimalP1: "The optimal weights (w*) are derived from the following optimization problem:",
          optimalP2: "",
          subjectTo: "subject to:",
          rcP8: "Here, ",
          rcP9: " represents the total portfolio volatility, and ",
          rcP10: " is the same.",
          advantagesTitle: "📌 Advantages of Risk Parity",
          advantages: [
            "✅ <bold>Stable portfolio</bold>: Allows for balanced investment without relying on high-volatility assets",
            "✅ <bold>No need for return forecasts</bold>: Asset allocation based solely on volatility",
            "✅ <bold>Resilient to market shocks</bold>: Limits the overall portfolio impact even during sharp declines in specific asset classes"
          ]
        },
        maxSharpe: {
          title: "📌 What is the Maximum Sharpe Ratio Portfolio?",
          p1: "The Sharpe Ratio is the value obtained by adjusting the portfolio's <bold>excess return by its volatility</bold>.",
          p2: "The Maximum Sharpe Ratio Portfolio is optimized to provide the <bold>highest expected return relative to risk</bold>, enabling investors to achieve high returns while efficiently taking on risk.",
          visualTitle: "📊 Visual Explanation of the MSR",
          visualDesc: "In the graph below, you can see the position of the <bold>Maximum Sharpe Ratio Portfolio</bold>.",
          bullet1: "🔵 <bold>Blue curve</bold>: Efficient Frontier (the optimal relationship between risk and expected return for various asset allocation combinations)",
          bullet2: "🌟 <bold>Star</bold>: Maximum Sharpe Ratio Portfolio (the portfolio with the highest risk-adjusted return)",
          altImg: "Maximum Sharpe Ratio Portfolio graph",
          mathTitle: "📌 Mathematical Model of the Maximum Sharpe Ratio Portfolio",
          sharpeFormulaTitle: "① Sharpe Ratio Formula",
          sharpeFormula: "S(w) = \\frac{E(R_p) - R_f}{\\sigma_p}",
          sharpeFormulaDesc: "Here:",
          sharpeDescList: [
            "E(R_p): Portfolio expected return",
            "R_f: Risk-free rate",
            "σ_p: Portfolio volatility"
          ],
          objectiveTitle: "② Objective Function for Optimal Weights",
          subjectTo: "subject to:",
          subjectFormula: "\\sum_{i=1}^{n} w_i = 1",
          rcList1:" Portfolio expected return",
          rcList2:" Risk-free rate",
          rcList3:" Portfolio volatility"
        },
        blackLiterman: {
          title: "📌 What is the Black-Litterman Model?",
          p1: "The Black-Litterman model is a portfolio optimization framework designed to allow investors to allocate assets based on the existing market equilibrium (market portfolio) while incorporating <bold>their own market views</bold>.",
          p2: "Unlike the traditional mean-variance approach, which is sensitive to investors' expected return estimates, this model applies <bold>Bayesian statistical concepts</bold> to combine market information with the investor's subjective views, thereby generating a more stable portfolio.",
          marketTitle: "📌 Market Equilibrium Returns",
          marketDesc: "First, the implied equilibrium returns (π) are computed based on market capitalization weights and other factors.",
          afterPi: "",
          marketWhere: "Here:",
          lambdaDesc: "The investor's risk aversion coefficient. It is generally calculated as λ = (E(R_mkt) - R_f) / σ_mkt², where E(R_mkt) is the market expected return, R_f is the risk-free rate, and σ_mkt² is the market variance.",
          sigmaDesc: "The covariance matrix among assets",
          wmktDesc: "Market capitalization weights",
          viewsTitle: "📌 Incorporating Investor Views",
          viewsDesc: "Investors can present <bold>their own views</bold> on specific assets.",
          blpExpectedReturn: "The Black-Litterman model incorporates these views to derive a new expected return ",
          blpExpectedReturnAfter: ".",
          bayesianTitle: "📌 Bayesian Integration",
          bayesianDesc: "The Black-Litterman model utilizes a <bold>Bayesian approach</bold> to <bold>integrate market equilibrium returns with the investor's subjective views</bold>. This process computes a more stable and realistic expected return vector E[R], which is then used to determine the optimal portfolio weights.",
          mathTitle: "📌 Overview of the Mathematical Model",
          expectedReturnTitle: "① Expected Return After Incorporating Investor Views",
          afterExpectedReturn: "",
          tauDesc: "A scaling parameter for the market covariance matrix",
          PDesc: "A matrix representing the investor's views (reflecting specific asset perspectives)",
          omegaDesc: "A covariance matrix representing the uncertainty in the views",
          QDesc: "The vector of returns expected by the investor (views vector)",
          optimalTitle: "② Optimal Portfolio Weights",
          blpOptimalDesc: "Based on the new expected returns, the portfolio weights that maximize the investor's utility ",
          blpOptimalAfter: " are derived.",
          optimalFormula: "w^* = \\frac{1}{\\lambda} \\Sigma^{-1} E[R]",
          advantagesTitle: "📌 Advantages of the Black-Litterman Model",
          advantages: [
            "✅ <bold>Stability</bold>: Prevents extreme portfolio weights by using market equilibrium returns as a baseline",
            "✅ <bold>Incorporates investor views</bold>: Allows for customized portfolio construction by reflecting individual perspectives",
            "✅ <bold>Realistic portfolio construction</bold>: Generates balanced investment weights by considering market information"
          ]
        }
      },

      analysisPastDataBased: "Analysis Based on Past Data",
      downloadMarketData: "📥 Download Market Data",
      dataSource: "Data Source:",

      downloadLimitWarning: "⚠️ Downloads are limited to once every 10 minutes. Please try again later.",
      downloadInProgress: "📥 Preparing the CSV file. You will be notified when the download is ready!",
      downloadComplete: "✅ CSV file download completed!",
      downloadError: "❌ An error occurred while downloading the CSV. Please try again.",
      confirmBrowserNotice: "Downloading may not work smoothly in KakaoTalk.\nWe recommend using a different browser.\n\nDo you want to continue?",
      downloadInProgressAlert: "⚠️ CSV download is already in progress. Please wait a moment.",
      loadingData: "📊 Loading data...",
      fetchError: "❌ An error occurred while loading data. Please try again later or refresh the page.",
      noPortfolio: "Please enter portfolio tickers.",
      equalPortfolioError: "Error loading Equal Weighted portfolio data",
      optimizedPortfolioError: "Error loading optimized portfolio data",
      
      addedTicker: "is already added",

      BacktestTooltip: "1. The calculation is based on the common dates of all selected items. Therefore, any dates with missing data are excluded.\n2. The adjusted closing price is used to reflect the total return, assuming dividends are reinvested.",

      portfolioCreated:"Portfolio successfully created!",

      
      "LoginPromtToast": {
          "required_message": "Login is required.",
          "google_notice": "Google login may be restricted in in-app browsers (e.g., KakaoTalk).",
          "backtest": {
            "title": "Extend the period for deeper insights.",
            "description1": "Analysis beyond 10 years is exclusive to members.",
            "description2": "Log in to access <strong>free analysis for up to 30 years</strong>.",
            "browser_notice": "* Google login may be restricted in in-app browsers (e.g., KakaoTalk).",
            "button": "Log in to Continue"
          }
      },

      // --- 추가: Risk 컴포넌트 관련 번역 ---
      risk: {
        // 상단 인트로 문구
        intro: "Can I handle the loss in my portfolio?",
        introSub: "Assess the potential maximum loss of your portfolio using historical data and statistical models.",
        period: {
           "d": "Daily",
            "w": "Weekly (Rolling)",
            "m": "Monthly (Rolling)",
            "q": "Quarterly (Rolling)",
            "a": "Annual (Rolling)", // '연간 (롤링)' -> Annual (Rolling)

            // 전체 키 (긴 단어)
            "daily": "Daily",
            "weekly": "Weekly",
            "monthly": "Monthly",
            "quarterly": "Quarterly",
            "annual": "Annual"
        },

        // 용어사전 토글 버튼 텍스트
        toggleExplanation: {
          open: "Glossary ▼",
          close: "▲ Close"
        },
        // VaR 관련 설명
        var: {
          definition: "VaR (Value at Risk)",
          explanation: "It represents the maximum expected loss at a given confidence interval. For example, if the Historical VaR is -5%, it means there is a (1 - confidence level) probability that daily losses will exceed -5%."
        },
        // 히스토리컬 VaR
        historicalVaR: {
          definition: "Historical VaR",
          explanation: "Historical VaR is calculated based on past actual returns. It is set as the boundary of the lower loss distribution, arranged in order, according to the set confidence interval.",
          title: "⏰ Historical VaR",
          description: "Based on historical data, there is a {{percent}}% chance that {{period}} loss will exceed this value."
        },
        // 파라메트릭 VaR
        parametricVaR: {
          definition: "Parametric VaR",
          explanation: "Parametric VaR is a theoretical VaR calculated under the assumption that returns follow a normal distribution. If the actual data deviates significantly from a normal distribution, it may differ greatly from the Historical VaR.",
          title: "📈 Parametric VaR",
          description: "Assuming a normal distribution, there is a {{percent}}% chance that {{period}} loss will exceed this value."
        },

        adddedTicker:"This ticker has already been added.",

        // 신뢰구간 설명
        confidenceInterval: {
          definition: "Confidence Interval",
          explanation: "For example, a 95% confidence interval means there is a 5% probability that daily losses will exceed the VaR value. The higher the confidence interval, the larger the VaR (expected loss), leading to a more conservative calculation."
        },
        // 주요 설정
        settings: {
          title: "Main Settings",
          dataPeriod: "Data Period:",
          year: "Y",
          confidence: "Confidence Level:"
        },
        // 포트폴리오 입력 관련
        portfolioInput: {
          title: "Portfolio Input",
          selectCurrency: "Select Currency:",
          instruction: "Enter ticker and weight(%)'.",
          confirm: "Confirm",
          edit: "Edit",
          delete: "Delete",
          addTicker: "+ Add Ticker",
          calculate: "Calculate",
          totalInvestment: "Investment Amount",
          totalWeight: "Total Weight",
          weightPlaceholder: "ex) 30%"
        },
        // 경고 메시지
        alerts: {
          noConfirmed: "No confirmed tickers. Please select a ticker.",
          zeroInvestment: "Total investment is 0. Please enter an amount.",
          noTicker: "Please enter a ticker symbol.",
          noAmount: "Please enter an amount.",
          noTickersOrWeights: "Please enter tickers and weights correctly.",
          totalWeightNot100: "Total weight is not 100% (Current: {{sum}}%). Please check again.",
          invalidTotalInvestment: "Invalid total investment amount. Please enter a positive number.",
          dataError: "An error occurred while fetching data."
        },
        // 차트 영역
        chart: {
          "title": {
            "daily": "Daily Return Distribution",
            "weekly": "Weekly Return Distribution",
            "monthly": "Monthly Return Distribution",
            "quarterly": "Quarterly Return Distribution",
            "annual": "Annual Return Distribution"
          },
          "xaxis": {
            "daily": "Daily Return",
            "weekly": "Weekly Rolling Return",
            "monthly": "Monthly Rolling Return",
            "quarterly": "Quarterly Rolling Return",
            "annual": "Annual Rolling Return"
          },
          subtitle: "({{start}} ~ {{end}})"
        },
        // Plot 범례 및 레이블
        plot: {
          upperHistorical: "Upper ({{confidence}}%) Historical",
          lowerHistorical: "Lower ({{confidenceComplement}}%) Historical",
          upperParametric: "Upper ({{confidence}}%) Parametric",
          lowerParametric: "Lower ({{confidenceComplement}}%) Parametric",
          title: "Historical Distribution & Parametric Estimation",
          xaxis: "Daily Return (%)",
          yaxis: "Frequency (Number of Trading Days)"
        },
        // 입력 placeholder
        placeholder: {
          KRW: "Example: 1000₩",
          USD: "Example: 1000$",
          EUR: "Example: 1000€",
          totalInvestment: "ex) 10,000",
        },
      "riskContribution": {
        "title": "Risk Contribution by Asset",
        "subtitle": "Contribution of each asset to the total Portfolio VaR (Negative values indicate diversification effect)",
        "chartTitle": "Risk Contribution"
      },
      "marginalVaR": {
        "title": "Loss Contribution Analysis",
        "subtitle": "Estimated change in total portfolio risk when adjusting the weight of a specific asset",
        "recommendation": "Risk Reduction Path",
        "change1pct": "Risk Change from 1% Weight Reduction",
        "recommend": {
          "reduce": "Reduce",
          "maintain": "Increase",
          "neutral": "Maintain"
        },
        "explain": {
          "reduce": "Can reduce total risk",
          "maintain": "Provides diversification effect",
          "neutral": "Impact is negligible"
        }
      },
      "whatIf": {
        "change": "Weight Change Simulation",
        "result": "Expected VaR Change"
      },
      "ticker":"Ticker",
      "currentWeight": "Weight",
      "total": "Total",
      "sim_assumption": "💡 Total weight reduction assumes conversion to cash, while an increase assumes borrowing (leveraging). (100 bp = 1%)",
      "riskContribution_absolute": "Absolute Contribution (%)",
       "max_minimize": "Maximum reduction"
    }
      ,diversification: "📋 Stock List Analyzer"
      ,correlation: {  
        introMain: "Are my selected stocks truly diversified?",
        introSub: "Many stocks moving alike won't lower your risk. Check and improve your portfolio!",
        resultTitle: "Correlation Analysis",
        calculate: "Analyze",
        alerts: {
          minStocks: "Please select at least 3 stocks.",
          invalidDateRange: "The start date cannot be later than the end date.",
          fetchError: "Failed to load data. Please ensure data for all selected items is available throughout the selected date range."
        },
        analysisPeriod: {
          title: "Analysis Period",
          periodRange: "{{startDate}} ~ {{endDate}} ({{dayCount}} days)",
          tooltip: "This period represents the dates common to all selected items. Missing data may affect the analysis results."
        },
        day: "days",
      
        analysis: {
          highCorrCombinationTitle: "🔺 Concentration Risk Alert: Highly Similar Asset Movements (0.7+ Correlation):",
          highCorrWarning: "🔺 The following pairs move like 'doppelgängers.' Even if the stocks are different, the effect is like buying just one, concentrating your risk.",
          correlationListTitle: "📊 Asset Combinations:",
          groupHeader: "📌 {{group}}",
          highCorrPairItem: "  - {{other}}",
          noHighCorr: "✅ No 'Doppelgänger' Pairs: Every stock shows unique characteristics with no significant overlap when compared 1:1.",
          lowCorrAssetsTitle: "🔹 Assets Contributing to Stability: (Stocks moving independently from others)",
          lowCorrAssetItem: "- {{asset}}",
          allAssetsCorrelated: "⚠️ Lack of Defensive Assets: Consider adding independent assets that can hold their ground during a downturn."
        }
        ,
        cluster: {
          group: "Group {{group}}",
          groupCount: "Groups",
          description: "Classify the most similar stocks based on the specified number of groups"
        },
        scatter: {
          perfectPositive: "Correlation Coefficient 1 (Perfect Positive Correlation)",
          perfectPositiveTitle: "Correlation Coefficient 1",
          positive07: "Correlation Coefficient 0.7 (Positive Correlation)",
          positive07Title: "Correlation Coefficient 0.7",
          uncorrelated: "Correlation Coefficient 0 (No Correlation)",
          uncorrelatedTitle: "Correlation Coefficient 0",
          negative07: "Correlation Coefficient -0.7 (Negative Correlation)",
          negative07Title: "Correlation Coefficient -0.7",
          perfectNegative: "Correlation Coefficient -1 (Perfect Negative Correlation)",
          perfectNegativeTitle: "Correlation Coefficient -1",
          axisX: "X",
          axisY: "Y"
        },
        pca: {
          title2D: "Movement Analysis (2D) - Principal Trend 1 ({{exp1}}% explained) vs Principal Trend 2 ({{exp2}}% explained)",
          title3D: "Movement Analysis (3D) - Principal Trend 1 ({{exp1}}%), Principal Trend 2 ({{exp2}}%), Principal Trend 3 ({{exp3}}%)",
          axisX: "Principal Trend 1 ({{exp}}% explained)",
          axisY: "Principal Trend 2 ({{exp}}%)",
          axisZ: "Principal Trend 3 ({{exp}}%)",
          buttons: {
            "2d": "View in 2D",
            "3d": "View in 3D"
          },
          explanation: {
            main: "Stocks clustered together move in the 'same pack,' while those farther apart complement each other's losses. About <bold>{{value}}</bold> of the overall movement is shown here.",
            note: "The greater the distance between stocks, the stronger the diversification effect."
          }
        },
       
        diagnosis: {
          title: "Portfolio Health Check",
          marketRiskExposure: "■ Major Trend Dependency: {{exposure}}%", 
          diversificationBalanceScore: "■ Theme Concentration Defense: {{score}} / 10", 
          correlationSpreadScore: "■ Inter-stock Independence: {{score}} / 10" 
        },
        interpretation: {
          marketRiskExposure: {
            low: "Independent. The portfolio follows its own path, staying resilient against overall market swings.",
            medium: "Well-Balanced. Tracks the general market trend while allowing individual stock characteristics to shine.",
            high: "Market-Tracking. Movements are highly unified; your stocks are acting as one giant block, increasing systemic risk."
          },
          diversificationBalance: {
            low: "Theme Concentration 🚨: Too many stocks are moving in sync within a specific theme. This 'crowding' makes your entire portfolio vulnerable to sector-specific shocks.",
            medium: "Caution Required: Some independent stocks exist, but a specific theme group still dominates over half of the portfolio's influence.",
            high: "Excellent Balance 👍: No single theme dominates. Your portfolio is well-structured across multiple groups for stable defense."
          },
          correlationSpread: {
            low: "Poor Diversification: Stocks move too similarly when compared 1:1. They won't be able to protect each other during a market crash.",
            medium: "Average Offset: Some differences exist. Adding one or two stocks with distinct movement patterns would improve stability.",
            mediumPlus: "Good 👍: Inter-stock independence is reasonably maintained.",
            high: "Outstanding 🏆: No stocks move exactly alike! You have selected unique assets that move independently."
          }
        },
        
        heatmap: {
          hide: "Hide",
          show: "View Overall Relationships",
          title: "Relationship Chart",
          explanation: "Redder shades indicate similar movements, bluer shades indicate opposite movements, and yellow indicates independent behavior."
        },
        
        similarityAnalysis: {
          title: "Visualizing Stock Movements in One View",
          cluster: {
            groupCount: "Number of Groups",
            description: "Classify the most similar stocks based on the specified number of groups"
          }
        },
        explanation: {
          title: "What is Correlation?",
          desc: "A statistical method analyzing how the prices or returns of different assets move together."
        },
        risk: {
          toggleExplanation: {
            open: "Show Explanation",
            close: "Hide Explanation"
          }
        },
        loadExample: "Load Example",
        enterticker: "Enter Stock Ticker",
        resetStocks: "Reset Stocks",
        dateRange: {
          sixM: "6M",
          oneY: "1Y",
          twoY: "2Y",
          threeY: "3Y",
          fourY: "4Y",
          fiveY: "5Y",
          sixY: "6Y",
          sevenY: "7Y",
          eightY: "8Y",
          nineY: "9Y",
          tenY: "10Y",
          twentyY: "20Y",
          thirtyY:"30Y",
          max: "Max",
          custom: "Custom"
        },
        viewDetail: "Details", 
        groupSimilarity: "Cluster Analysis",
        viewHeatmap: "View Relationships",
        hideHeatmap: "Hide"

      }


      // ,correlation: {  
      //   introMain: "Are my selected stocks truly diversified?",
      //   introSub: "Many stocks moving alike won't lower your risk. Check and improve your portfolio!",
      //   resultTitle: "Correlation Analysis",
      //   calculate: "Analyze",
      //   alerts: {
      //     minStocks: "Please select at least 3 stocks.",
      //     invalidDateRange: "The start date cannot be later than the end date.",
      //     fetchError: "Failed to load data. Please ensure data for all selected items is available throughout the selected date range."
      //   },
      //   analysisPeriod: {
      //     title: "Analysis Period",
      //     periodRange: "{{startDate}} ~ {{endDate}} ({{dayCount}} days)",
      //     tooltip: "This period represents the dates common to all selected items. Missing data may affect the analysis results."
      //   },
      //   day: "days",
      
      //   analysis: {
      //     highCorrCombinationTitle: "🔺 Concentration Risk Alert: Highly Similar Asset Movements (0.7+ Correlation):",
      //     highCorrWarning: "🔺 These pairs move very similarly. The risk of significant loss increases if they drop together.",
      //     correlationListTitle: "📊 Asset Combinations:",
      //     groupHeader: "📌 {{group}}",
      //     highCorrPairItem: "  - {{other}}",
      //     noHighCorr: "✅ Good Management: No high-risk combinations (0.7+ correlation). You've successfully avoided concentration risk.",
      //     lowCorrAssetsTitle: "🔹 Portfolio Stabilizing Assets: (Movements less than 0.3 correlation with others)",
      //     lowCorrAssetItem: "- {{asset}}",
      //     allAssetsCorrelated: "⚠️ Potential Lack of Diversification: Consider adding assets that move independently. (All assets have movements of 0.3+ correlation)"
      //   }
      //   ,
      //   cluster: {
      //     group: "Group {{group}}",
      //     groupCount: "Groups",
      //     description: "Classify the most similar stocks based on the specified number of groups"
      //   },
      //   scatter: {
      //     perfectPositive: "Correlation Coefficient 1 (Perfect Positive Correlation)",
      //     perfectPositiveTitle: "Correlation Coefficient 1",
      //     positive07: "Correlation Coefficient 0.7 (Positive Correlation)",
      //     positive07Title: "Correlation Coefficient 0.7",
      //     uncorrelated: "Correlation Coefficient 0 (No Correlation)",
      //     uncorrelatedTitle: "Correlation Coefficient 0",
      //     negative07: "Correlation Coefficient -0.7 (Negative Correlation)",
      //     negative07Title: "Correlation Coefficient -0.7",
      //     perfectNegative: "Correlation Coefficient -1 (Perfect Negative Correlation)",
      //     perfectNegativeTitle: "Correlation Coefficient -1",
      //     axisX: "X",
      //     axisY: "Y"
      //   },
      //   pca: {
      //     title2D: "PCA Results (Clustering Applied, 2D) - Principal Trend 1 ({{exp1}}% explained) vs Principal Trend 2 ({{exp2}}% explained)",
      //     title3D: "PCA Results (Clustering Applied, 3D) - Principal Trend 1 ({{exp1}}%), Principal Trend 2 ({{exp2}}%), Principal Trend 3 ({{exp3}}%)",
      //     axisX: "Principal Trend 1 ({{exp}}% explained)",
      //     axisY: "Principal Trend 2 ({{exp}}%)",
      //     axisZ: "Principal Trend 3 ({{exp}}%)",
      //     buttons: {
      //       "2d": "View in 2D",
      //       "3d": "View in 3D"
      //     },
      //     explanation: {
      //       main: "Stocks that are closer together exhibit similar behavior, while those farther apart contribute to greater diversification. The chart below explains about <bold>{{value}}</bold> of the overall movement.",
      //       note: "Stocks that are closer together exhibit similar behavior, while those farther apart contribute to greater diversification."
      //     }
      //   },
       
      //   diagnosis: {
      //     title: "Portfolio Diversification Diagnosis",
      //     marketRiskExposure: "■ Market Linkage Level: {{exposure}}%", 
      //     diversificationBalanceScore: "■ Risk Concentration Balance: {{score}} / 10", 
      //     correlationSpreadScore: "■ Asset Offset Power: {{score}} / 10" 
      //   },
      //   interpretation: {
      //     marketRiskExposure: {
      //       low: "Independent. Likely to pursue unique returns regardless of the overall market movement.",
      //       medium: "Well-Balanced. Tracks the market trend but still reflects individual stock performance.",
      //       high: "Market-Tracking. The portfolio's movement is heavily determined by the general market direction."
      //     },
      //     diversificationBalance: {
      //       low: "Concentration Alert 🚨: Stocks are moving similarly, locked into a specific theme or factor. Vulnerable to concentrated risk.",
      //       medium: "Review Recommended: Movement is skewed toward one direction, but a few unique stocks provide partial offset.",
      //       high: "Excellent Balance 👍: Stock movements are spread well, preventing risk from concentrating on any single factor."
      //     },
      //     correlationSpread: {
      //       low: "Poor Diversification: Stocks move too similarly, resulting in minimal risk offset. High risk of simultaneous decline.",
      //       medium: "Average Offset: Risk offset is moderate. Consider adding stocks with distinct movement patterns to improve diversification.",
      //       mediumPlus: "Quite Strong: Risk is well-offset between assets. A few minor adjustments could lead to greater stability.",
      //       high: "Outstanding 🏆: Assets move differently from each other, demonstrating superior power to offset losses with gains."
      //     }
      //   },
        
      //   heatmap: {
      //     hide: "Hide",
      //     show: "View Overall Relationships",
      //     title: "Relationship Chart",
      //     explanation: "The redder it is, the more similarly the stocks move. The bluer it is, the more oppositely they move. Yellowish colors indicate close to no correlation."
      //   },
        
      //   similarityAnalysis: {
      //     title: "Visualizing Stock Movements in One View",
      //     cluster: {
      //       groupCount: "Number of Groups",
      //       description: "Classify the most similar stocks based on the specified number of groups"
      //     }
      //   },
      //   explanation: {
      //     title: "Correlation",
      //     desc: "A statistical method for analyzing how the prices or returns of different assets move together."
      //   },
      //   risk: {
      //     toggleExplanation: {
      //       open: "Show Explanation",
      //       close: "Hide Explanation"
      //     }
      //   },
      //   loadExample: "Load Example",
      //   enterticker: "Enter Stock Ticker",
      //   resetStocks: "Reset Stocks",
      //   dateRange: {
      //     sixM: "6M",
      //     oneY: "1Y",
      //     twoY: "2Y",
      //     threeY: "3Y",
      //     fourY: "4Y",
      //     fiveY: "5Y",
      //     sixY: "6Y",
      //     sevenY: "7Y",
      //     eightY: "8Y",
      //     nineY: "9Y",
      //     tenY: "10Y",
      //     twentyY: "20Y",
      //     thirtyY:"30Y",
      //     max: "Max",
      //     custom: "Custom"
      //   },
      //   viewDetail: "Details", 
      //   groupSimilarity: "Cluster Analysis",
      //   viewHeatmap: "종목 관계 보기",
      //   hideHeatmap: "숨기기"

      // }
      ,navPage: {
        hero: {
          title: "Don't Guess. Validate Your Strategy.", 
          subtitle: "Backtest your portfolio with historical data in seconds to see the truth behind the numbers.",
          button: "Start Backtest Now"
        },

        // [NEW] Expert Tools: 하단으로 이동한 도구들의 제목
        expertTools: {
          label: "Portfolio Optimization"
        },
        quickActions: {
          "group": {
            "label": "Portfolio Optimization",
            "alloc": "Asset Allocation",
            "risk": "Risk Analysis",
            "corr": "Correlation Analysis",
            "backtest": "Backtesting",
            "sim": "Simulation",
            "sentiment": "Market Sentiment"
          },
          "group2": {
            "label": "Portfolio Optimization",
            "alloc": "📊 Asset Allocation",
            "risk": "⚠️ Risk Analysis",
            "corr": "📋 Correlation Analysis",
            "backtest": "🔄️ Backtesting",
            "sim": "🎲 Simulation",
            "sentiment": "💡 Market Sentiment"
          },
          ranking: "Portfolio Ranking",
          insight: "Investment Insights",
          ranking2: "🏆 Portfolio Ranking",
          insight2: "📖 Investment Insights"
        },
        topPortfolios: {
          title: "Top Portfolios",
          subtitle: "Explore top-performing investment strategies across various criteria",
          empty: "Loading..."
          // empty: "No portfolios with more than 30 days of operation."
        },
         "period": {
          "recent30Days": "1M"
        },
        sort: {
          return: "Return",
          sharpe: "Sharpe Ratio",
          mdd: "MDD",
          calmar: "Calmar Ratio",
          volatility: "Volatility"
        },
        metric: {
          return: "Return",
          sharpe: "Sharpe Ratio",
          mdd: "Max Drawdown",
          calmar: "Calmar Ratio",
          volatility: "Volatility"
        },
        sharpeInfo: "The Sharpe ratio measures a portfolio's 'return per unit of risk'. A higher ratio means better performance for the amount of risk taken.",
        calmarInfo: "The Calmar ratio measures a portfolio's 'recovery from maximum drawdown'. A higher ratio indicates a better ability to recover from losses and generate stable returns.",
        daysActive: "{{days}} days active",
        viewAllPortfolios: "View All Portfolios",
        latestInsights: {
          title: "Latest Insights",
          subtitle: "Gain investment knowledge to help you on your journey.",
          empty: "Be the first to share an insight!"
        },
        defaultAuthor: "QuanPort Team",
        viewAllPosts: "View All Insights"
      }
      ,
      announcementPopup: {
        newFeaturesTitle: "New features have been added to QuanPort!",
        subtitle: "Upgrade your investment experience with our more powerful features.",
        portfolioAnalysisTitle: "Portfolio Analysis",
        portfolioAnalysisDesc: "Register your own portfolio and analyze its performance in detail.",
        shareInsightsTitle: "Share Insights",
        shareInsightsDesc: "Share your investment know-how and expand your influence.",
        visionText: "QuanPort aims to build a sustainable growth model for creators.",
        futurePlanText: "In the future, we plan to create an environment where your insights can lead to profit through the introduction of premium subscriptions.",
        dontShowToday: "Do not show for one week",
        close: "Close"
        ,serverError: {
            title: "Thank You for the Incredible Interest! 🔥",
            subtitle: "More users than ever are currently using our <br/>Portfolio Optimization service.",
            statusTitle: "Emergency System Scaling in Progress",
            statusDesc: "To ensure a seamless experience, we are doubling our server capacity.<br/>The <strong>Portfolio Optimization</strong> feature may be temporarily delayed.",
            waitTitle: "We’ll Be Right Back",
            waitDesc: "We appreciate your patience as we work to provide you with even faster service.",
            otherFeaturesTitle: "Other Services are Active",
            otherFeaturesDesc: "Market analysis and community insight features are still fully available for use.",
            dontShowToday: "Don't show again today",
            buttonText: "I'll check back later!"
        }
      }
      ,
      postDetail: {
        loading: "Loading...",
        error: "Failed to load the post.",
        notFound: "Post not found.",
        unknownUser: "Unknown User",
        goBack: "Go Back",
        navigateToAuthorPageTitle: "Go to {{nickname}}'s profile page",
        profileAlt: "{{nickname}}'s profile image",
        unfollow: "Unfollow",
        follow: "Follow",
        following: "Following",
        removeSavedTitle: "Remove from saved posts",
        saveTitle: "Save for later",
        saved: "Saved",
        save: "Save",
        alreadyLikedTitle: "You have already liked this post",
        like: "Like",
        likeCountText: "{{count}} Likes"
      },
      postLists: {
        searchPlaceholder: "Search articles...",
        loadingInitial: "Loading post list...",
        loadingMore: "Loading...",
        loadingFailed: "Failed to load posts: {{message}}",
        filteredByAuthor: "Posts by {{nickname}}",
        clearFilter: "Clear filter",
        noPosts: "Be the first to share an Insight!",
        endOfPosts: "No more posts.",
        topPortfoliosTitle: "Top 10 Portfolios",
        topPortfoliosByCategory: "Top 10 Portfolios by Category",
        categoryReturn: "Highest Return",
        categorySharpe: "Highest Sharpe Ratio",
        categoryVolatility: "Lowest Volatility",
        // noPortfoliosInCategory: "No portfolios in this category.",
        noPortfoliosInCategory: "No portfolios with more than 30 days of operation.",
        unnamedPortfolio: "Unnamed Portfolio",
        profileAlt: "{{nickname}}'s profile",
        likes: "Likes",
        comments: "Comments",
        date: "Date"
      }
      ,
      tagInput: {
        maxTagsPlaceholder: "Maximum of {{count}} tags",
        removeTagButton: "Remove tag"
      }
      ,
      writePost: {
        button: "Insights",
        cancel: "Cancel",
        confirm: "Confirm",
        loginRequiredTooltip: "You can use this service after logging in.",
        fetchError: "Failed to load post: {{message}}",
        imageSizeError: "Image size exceeds {{max_size}}MB.",
        loginRequired: "Login is required.",
        updateFailed: "Failed to update post: {{message}}",
        submitFailed: "Failed to submit post: {{message}}",
        titlePlaceholder: "Enter title",
        contentPlaceholder: "Enter or paste content...",
        authChecking: "Checking authentication...",
        processing: "Processing...",
        editPost: "Edit Post",
        submitPost: "Submit Post",
        modalEditTitle: "Edit Post",
        modalSettingsTitle: "Post Settings",
        previewPlaceholder: "Enter preview content",
        tagsPlaceholder: "Enter tags",
        uploading: "Uploading...",
        uploadPreviewImage: "Upload preview image",
        previewUploadError: "Failed to upload preview image: {{message}}",
        remove: "Remove",
        paidPost: "Paid Post",
        // comingSoon: "The paid post feature will be available soon. Authors will be able to set a subscription fee between $1 and $100 per month.",
        comingSoon: "We are preparing a creator reward system. Currently, all insights are offered for free. To compensate our creators for their efforts, we are considering a proposal to share profits through an ad revenue sharing model.",
        titleRequired: "Please enter a title for your post.",
        contentRequired: "Please enter content for your post."
      }
      ,
      portfolios: {
        pageTitle: "All Portfolios",
        title: "All Portfolios",
        toast: {
          creationSuccess: "Your portfolio has been successfully created! 🚀The rate of return is calculated based on the most recent closing price of all assets in the portfolio. Please note: If you create your portfolio while the market is open, the calculation will start with today's closing price. If the market is closed, it will start with the previous trading day's closing price."
        },
        loadingInitial: "Loading portfolios...",
        title: "📈 Portfolio Ranking",
        updateInfo: "Update Time: Daily at 09:00 (UTC+09:00)",
        "liveTab": "🚀 Live Rankings",
        "fameTab": "👑 Hall of Fame",
        "fame": {
          "selectionCriteria": "Selection Criteria",
          "selectionValue": "Top 10% in Return, Sharpe, or MDD",
          "update": "Update",
          "updateValue": "Daily 09:00 (KST), Closes every Friday",
          "ranking": "Ranking",
          "rankingValue": "Relative ranking within the group (Returns prioritized for ties)"
        },
        emptyList: "Register your first portfolio.",
        lockedTooltip: "Results will be displayed after 21 trading days.",
        tableHeaders: {
          user: "User",
          portfolio: "Portfolio",
          return: "Return",
          maxDrawdown: "Max Drawdown",
          volatility: "Volatility",
          sharpe: "Sharpe",
          sortino: "Sortino",
          calmar: "Calmar",
          days: "Days"
        },
        period: {
          all: "All",
        },
        unit: {
          days: ""
        },
        viewButton: "View",
        tableUpdating: "Updating portfolio list...",
        loadingMore: "Loading more portfolios...",
        createButton: "Build My Portfolio",
        createButton2: "Register portfolio",
        createButton3: "Start My Portfolio",
        createButton4: "Track Performance",
        createButton5: "Save Portfolio",
        loginRequiredTooltip: "Login is required",
        unnamed: "Unnamed",
        successMessage:"Portfolio successfully created!",
        tooltip: {
          return: "Return over the selected period.",
          maxDrawdown: "Maximum percentage decline from a peak to a trough **during the selected period**.",
          volatility: "Standard deviation of price fluctuations.",
          sharpe: "Risk-adjusted return (efficiency) ratio.",
          sortino: "Risk-adjusted return considering only downside risk.",
          calmar: "Annualized return divided by the maximum drawdown."
        }
      },
      portfolioDetail: {
        loading: "Loading...",
        error: "Error: ",
        title: "🏆 Portfolio Ranking",
        ownerDescription: "Portfolio creator",
        visitPageButton: "Visit page ↗️",
        followButton: "Follow",
        followingButton: "Following",
        calculationExplanationTitle: "Return Calculation Method",
        calculationExplanationToggle: {
          open: "Show explanation",
          close: "Hide explanation"
        },
        calculationExplanationText: {
          p1: "When the market is closed (e.g., weekends), the last **closing price** is used as the starting price. On market days, the calculation is based on the **closing price** at the end of the day.",
          p2: "If the closing times for stocks in the portfolio differ, the return is calculated after all markets have closed.",
          p3: "The calculation assumes dividend reinvestment and uses the **'adjusted closing price'** which accounts for dividends.",
        },
        compositionTitle: "📊 Current Asset Weights",
        compositionHistoryTitle: "🗓️ History",
        compositionHistoryToggle: {
          open: "Asset weight changes",
          close: "Asset weight changes"
        },
        cumulativeValueTitle: "📊 Cumulative Value",
        drawdownTitle: "📉 Drawdown History",
        commentSectionTitle: "Comments",
        unnamed: "Unnamed",
        noData: {
          title: "Portfolio Returns Calculation Guide",
          mainMessage: "Investment data will be available starting <1>2 business days</1> after portfolio creation.",
          calculationBasis: "Calculation Basis:",
          adjustedClosingPrice: "Adjusted closing price of the last trading day",
          dataUpdate: "Data Update:",
          dailyUpdateTime: "Every day at 9:00 AM (UTC+09:00)",
          tradingDayTitle: "When the market is open",
          tradingDayExample: "Created on a Wednesday → Available from <1>Friday at 9:00 AM</1>",
          tradingDayExplanation: "(after comparing Wednesday's and Thursday's closing prices)",
          nonTradingDayTitle: "When the market is closed",
          nonTradingDayExample:"Created on a Saturday → Available from <1>Tuesday at 9:00 AM</1>",
          nonTradingDayExplanation: "(after comparing Friday's and Monday's closing prices)"
        },

        // --- PortfolioRadarChart.js 에서 사용되는 항목 추가 ---
        "performanceRadarTitle": "📈 Performance",
        "tooltipTitle": "Metric Explanation",
        "referenceLine": "50% Reference Line",
        "percentile": "Percentile Score",
        "percentileScore": "Percentile Score",
        "noPeriodData": "Minimum operation days requirement was not met for the selected period.",
        "radarCaption": "Each metric is a percentile score compared to peer portfolios and benchmarks over the last {{period}}.",
        "radarBenchmarkTip": "50% Reference line: average of all portfolios and benchmarks.",
        "tooltips": {
          "return": "Percentile score of return for the same period.",
          "sharpe": "Risk-adjusted return (efficiency) score.",
          "calmar": "Score for return relative to Max Drawdown.",
          "stability": "Lower volatility results in a higher score.",
          "defense": "Lower Max Drawdown (MDD) results in a higher score."
        },

        // --- [중요] metrics가 portfolioDetail 안에 중첩됨 ---
        "metrics": {
          "return": "Return",
          "sharpe": "Sharpe",
          "calmar": "Calmar",
          "stability": "Stability", 
          "defense": "Defense"      
        },
        
        // --- [중요] periods가 portfolioDetail 안에 중첩됨 ---
        "periods": {
          "1w":"1W",
          "2w":"2W",
          "1m": "1M",
          "3m": "3M",
          "6m": "6M",
          "1y": "1Y",
          "2y": "2Y",
          "3y": "3Y"
        },
        // ✨ [Addition] Summary Section Title and Key Metrics
        "summaryTitle": "Summary", 
        "elapsedDaysInfo": "Elapsed: {{days}} days",
        "totalReturn": "Total Return",
        "mdd": "Max Drawdown (MDD)",
        "sharpe": "Sharpe Ratio",
        "volatility": "Volatility",

        // ✨ [Addition] Toggle Button Titles
        "attributionToggleTitle": "Performance Analysis",
        "timeSeriesToggleTitle": "Return & Drawdown Trend",
        "chartsToggleTitle": "Return and Drawdown Trend",
        "attributionTitle": "📈 Stock Contribution", 

        // ⭐ MISSING KEY 2: Analysis Mode Tabs
        "analysisMode": {
          "return": "Return (Contribution)",
          "risk": "Risk (Volatility)", 
          "defense": "Defense (MDD)" 
        },
        
        "attributionInsight": {
            "returnBest": " drove the return,",
            "returnWorst": " caused the largest loss.",
            "riskWorst": " increased volatility, but",
            "riskBest": " stabilized the portfolio.",
            "defenseWorst": " amplified the decline, and",
            "defenseBest": " performed well during the downturn."
        },

        // ✨ [New] Tooltip Text Keys
        "attributionTooltip": {
            "good": "Good 👍",
            "bad": "Bad 👎",
            "avgWeight": "Avg. Weight",
            "return": "Return",
            "volatility": "Volatility",
            "mdd": "MDD",
            "contribution": "Contribution"
        },
        "tab": {
          "PerformanceTrend": "Performance Trend",
          "Holdings": "Holdings" 
          // 이전 요청에서 사용되었으나, 최종적으로는 '현재 종목 비중'과 '성과 추이'만 남았습니다.
          // 만약 '현재 비중'을 '비중 분석'으로 유지하고 싶으시면 이 키를 사용하시면 됩니다.
          // 현재 코드(최종 버전)에서는 'currentComposition'과 'performanceCharts'만 사용됩니다.
        },

      },
      newPortfolioModal: {
        trackPortfolio: "Track Performance",
        confirmButton: "Confirm",
        modalMessage: {
          loginRequired: "You must be logged in to create a portfolio.",
          enterName: "Please enter a portfolio name.",
          enterTicker: "Please enter a ticker for all holdings. A ticker is required for holdings with a weight.",
          totalWeight: "The total weight must be 100%.",
          creationSuccess: "Portfolio successfully created!",
          creationError: "An error occurred while creating the portfolio.",
          serverError: "Failed to create portfolio.",
          limitExceededPublic:"The maximum limit for public portfolios (3) has been exceeded. (Performance Tracking 3, Private Storage 10)",
          limitExceededPrivate: "The maximum limit for private portfolios (10) has been exceeded. (Performance Tracking 3, Private Storage 10)",
        },
        title: "➕ Create New Portfolio",
        portfolioNameLabel: "Portfolio Name",
        portfolioNamePlaceholder: "e.g., Retirement fund portfolio",
        loginRequiredTooltip: "Available after login.",
        tableHeaders: {
          ticker: "Ticker",
          weight: "Weight (%)",
        },
        totalWeightLabel: "Total Weight:",
        weightWarning: "(Total weight is not 100%!)",
        addHolding: "Add Holding",
        createButton: "Create",
        deleteButton: "Delete Holding",
      },
      rebalanceModal: {
        loading:"Loading...",
        title: "🔄 Rebalance Portfolio",
        totalWeightLabel: "Total Weight:",
        addHoldingButton: "Add Holding",
        executeButton: "Execute Rebalance",
        loginRequiredTooltip: "Available after login.",
        alert: {
          confirm: "Confirm",
          totalWeight100: "Total weight must be 100%.",
          loginRequired: "Login is required.",
          permissionError: "You do not have permission to rebalance this portfolio.",
          notFoundError: "Portfolio not found.",
          generalError: "An error occurred during rebalancing.",
        },
      },
      userPage: {
        loadingUser: "Loading user information...",
        userNotFound: "User not found.",
        loadingError: "Failed to load user profile.",
        unknownUser: "Unknown user",
        portfolioLoadError: "Failed to load portfolios.",
        followerLoadError: "Failed to load follow lists.",
        followLoginRequired: "You must be logged in to follow.",
        followSelf: "You cannot follow yourself.",
        followSuccess: "Successfully followed {{nickname}}.",
        followFailed: "Failed to follow: {{error}}",
        unfollowConfirm: "Do you want to unfollow {{nickname}}?",
        unfollowFailed: "Failed to unfollow: {{error}}",
        tabPosts: "Home",
        tabAbout: "About",
        aboutTitle: "About",
        noIntroduction: "No introduction written.",
        investmentResults: "Investment Results",
        loadingPortfolios: "Loading portfolios...",
        noPortfolios: "No portfolios registered.",
        avg1YReturn: "Avg. 1Y Return:",
        avg1YSharpe: "Avg. 1Y Sharpe Ratio:",
        portfolioTableTitle: "Portfolios ({{count}})",
        tableHeaderName: "Portfolio Name",
        tableHeaderReturn: "1Y Return",
        tableHeaderSharpe: "1Y Sharpe Ratio",
        tableHeaderDuration: "Duration",
        day: "{{count}} days",
        unnamed: "Unnamed",
        followingTitle: "Following ({{count}})",
        followerTitle: "Followers ({{count}})",
        noFollowing: "This user is not following anyone yet.",
        noFollowers: "This user has no followers yet.",
        confirmButton: "Confirm",
        cancelButton: "Cancel",
        unfollowButton: "Following",
        followButton: "Follow",
        unfollowBtnAria: "Unfollow {{nickname}}",
        followBtnAria: "Follow {{nickname}}",
        profileImageAlt: "{{nickname}}'s profile picture",
        userPageTitle: "User page",
        userPostsList: {
          loadingPosts: "Loading posts...",
          loadingMore: "Loading more posts...",
          loadingError: "Failed to load posts:",
          noPosts: "No posts have been written yet.",
          endOfPosts: "No more posts to show.",
          postCount: "{{nickname}}'s Posts ({{count}})",
        },
        "followerTitleNoCount": "Followers",
        "followingTitleNoCount": "Following",
        "hallOfFame": "🏆 Hall of Fame",
        "topPerformance": "Top Performance Records",
        "trackRecords": "Track Records",
        "latestAchievement": "Latest Achievement",
        "metrics": {
          "return1Y": "Return (1Y)",
          "sharpe": "Sharpe",
          "yieldMaster": "Yield Master",
          "stabilityPro": "Stability Pro",
          "defenseExpert": "Defense Expert",
          "topRank": "{{label}} Top {{rank}}"
        }
      },
      signInPage: {
        loadingMessage: "Logging in...",
      },
      setNicknamePage: {
        title: "Set Nickname",
        introText: "Please set your nickname to use the service.",
        label: "Nickname:",
        "placeholder": "Nickname (max 10 chars)",
        errorNicknameRequired: "Please enter a nickname.",
        alertSuccess: "Your nickname has been successfully set!",
        errorFailed: "Failed to set nickname.",
        errorNetwork: "A network error occurred.",
        successMessage: "Nickname set!",
        buttonText: "Proceed",
      },
      loginComponent: {
        loading: "Loading...",
        login: "Log In",
        logout: "Log Out",
      },
       footerComponent: {
        feedbackButton: "Bug Report / Suggestions",
        alertSuccess: "Your message has been successfully sent!",
        alertFailure: "Failed to send message. Please try again.",
        modalTitle: "Send a Message",
        modalPlaceholder: "Enter your message here...",
        sendButton: "Send",
        closeButton: "Close",
      },
      commentSection: {
        title: "💬 Comments",
        empty: "Be the first to leave a comment!",
        placeholder: {
          newComment: "Enter your comment...",
          username: "Enter your nickname",
          password: "Password",
          reply: "Enter your reply...",
        },
        button: {
          submit: "Submit",
          submitting: "Submitting...",
          reply: "Reply",
          edit: "Edit",
          delete: "Delete",
          save: "Save",
          cancel: "Cancel",
          showReplies: "Show {{count}} replies",
          hideReplies: "Hide replies",
        },
        info: {
          loadingAuth: "Loading authentication info...",
          loggedInAs: "Replying as: {{username}}",
          anonymousUser: "Logged-in user",
          confirmDelete: "Are you sure you want to delete this comment?",
        },
        errors: {
          noTarget: "No target specified for comment.",
          noReplyTarget: "No target specified for reply.",
          noEditTarget: "No target specified for editing comment.",
          noDeleteTarget: "No target specified for deleting comment.",
          commentRequired: "Comment content is required.",
          allFieldsRequired: "Nickname, comment, and password are all required.",
          replyRequired: "Reply content is required.",
          replyFieldsRequired: "Nickname and password are required.",
          editTextRequired: "Please enter the text to edit.",
          passwordRequired: "Password is required.",
          authRequired: "You must be logged in to modify this comment.",
          fetchFailed: "Failed to load comments.",
          submitFailed: "Failed to submit comment.",
          replyFailed: "Failed to submit reply.",
          editFailed: "Failed to edit.",
          deleteFailed: "Failed to delete.",
          networkError: "A network error occurred: ",
        }
      },
      auth: {
        loading: "Authenticating...",
        error: "An error occurred during authentication.",
        errorCheckingNickname: "Failed to check nickname.",
        redirecting: "Redirecting...",
      },
      mypage: {
          loading:'Loading...',
          // 탭/기본 UI
          profile: 'Profile',
          portfolio: 'Portfolio',
          posts: 'Posts',
          confirm0: 'Confirm',
          cancel: 'Cancel',
          loading: {
            generic: 'Loading…',
          },

          // 온보딩 섹션
          onboardingTitle: '✨ Complete Your Financial DNA',
          onboardingText: 'By completing your Financial DNA, you can receive <1>more accurate portfolio analysis</1> and <1>content tailored to your preferences</1>.',
          getStarted: 'Get Started Now',

          // 팔로우 섹션
          loadingFollows: 'Loading follow information...',
          following: 'Following',
          followers: 'Followers',

          // 포트폴리오 섹션
          noPortfolioRegistered: 'No portfolios registered.',
          avg1yReturn: 'Avg. 1Y Return',
          avg1ySharpe: 'Avg. 1Y Sharpe Ratio',
          name: 'Name',
          elapsedDays: 'Days',
          dateSuffix: 'd',
          rebalance: 'Change',
          delete: 'Delete',
          registerNewPortfolio: 'Register New Portfolio',
          unnamedPortfolio: 'Unnamed Portfolio',
          table: {
            ret1y: '1Y RET',
            sr1y: '1Y SR',
          },

          publicTrackingPortfolios: 'Tracking Portfolios',
          noAllPortfolios: 'There are currently no tracking portfolios.',
          privateArchivedPortfolios: 'Archived Portfolios',
          noPrivatePortfolios: 'You currently have no private archived portfolios.',
          actions: 'Manage', 

          writePost: 'Write New Post',
          followedPosts_one: 'Feed',
          followedPosts_other: 'Feed',
          myPosts_one: 'My Post',
          myPosts_other: 'My Posts',
          savedPosts_one: 'Saved',
          savedPosts_other: 'Saved',
          writePost: 'Write New Post',

          "rebalanceSuccessMsg": "Rebalancing complete. Performance is calculated based on the closing price of the selected date and will be reflected starting the next trading day.",

          empty: {
            feed: 'No new updates yet. Follow other users to see their posts!',
            myPosts: 'No posts written.',
            savedPosts: 'No saved posts.',
          },
          post: {
            likes: 'Likes:',
            author: 'Author:',
            unknownAuthor: 'Unknown',
            createdAt: 'Date Created:',
          },
          action: {
            unsave: 'Unsave',
          },

          // 알림/오류/확인 메시지
          confirm: {
            unsavePost: 'Are you sure you want to remove this post from your saved list?',
            deletePortfolio: 'Are you sure you want to delete this portfolio?',
            deletePost: 'Are you sure you want to delete this post?',
            unfollowUser: 'Are you sure you want to unfollow {{nickname}}?',
          },
          alert: {
            postUnsaved: 'Post successfully unsaved.',
            nicknameUpdated: 'Nickname successfully updated.',
            introductionUpdated: 'Financial DNA successfully updated.',
            fileSizeExceeded: 'File size cannot exceed 5MB.',
            imageFormatUnsupported: 'Only JPEG, PNG, and WebP formats are supported.',
            profileImageUpdated: 'Profile photo successfully changed!',
            portfolioDeleted: 'Portfolio deleted.',
            postDeleted: 'Post deleted.',
            followLoginRequired: 'You must log in to follow.',
            followedUser: 'You are now following {{nickname}}.',
            unfollowLoginRequired: 'You must log in to unfollow.',
            unfollowedUser: 'You have unfollowed {{nickname}}.',
          },
          error: {
            feedLoad: 'Failed to load feed.',
            savedPostsLoad: 'Failed to load saved posts.',
            unsavePostGeneric: 'Failed to unsave post:',
            profileLoad: 'Failed to load profile.',
            followsLoad: 'Failed to load follow/follower list.',
            nicknameInvalid: 'Nickname format is invalid.',
            nicknameDuplicate: 'Nickname is already in use.',
            noProfile: 'No existing profile found.',
            nicknameUpdateFailed: 'Nickname update failed',
            introductionInvalid: 'Introduction format is invalid.',
            introductionUpdateFailed: 'Introduction update failed',
            introductionUpdateGeneric: 'Failed to update:',
            s3UrlFailed: 'Failed to get pre-signed URL.',
            s3UploadFailed: 'Failed to upload file to S3.',
            profileUpdateFailed: 'Profile update failed',
            profileImageUpdateGeneric: 'Failed to change profile photo:',
            portfolioLoad: 'Failed to load portfolios.',
            postsLoad: 'Failed to load posts.',
            deletePortfolio: 'Failed to delete portfolio:',
            deletePost: 'Failed to delete post:',
            followFailed: 'Follow failed:',
            unfollowFailed: 'Unfollow failed:',
          },
          modal: {
            // 공통 버튼
            button: {
              save: 'Save',
              cancel: 'Cancel',
            },

            // EditIntroductionModal
            intro: {
              title: 'My Financial DNA',
              error: {
                maxLength: 'Cannot exceed {{maxLength}} characters.',
              },
              placeholder: 'Example) I am a long-term growth investor based on macroeconomic analysis. I am interested in the IT and Bio sectors.',
            },

            // EditNicknameModal
            nickname: {
              title: 'Change Nickname',
              label: 'New Nickname:',
              error: {
                required: 'Please enter a nickname.',
              },
            },

            // EditProfileImageModal
            image: {
              title: 'Change Profile Image',
              alert: {
                unsupportedFormat: 'Only JPEG, PNG, and WebP formats are supported.',
                sizeExceeded: 'File size cannot exceed {{maxSizeMB}}MB.',
              },
              placeholder: 'Preview',
            },

            // FollowListModal
            follow: {
              title: {
                following: 'Following List',
                followers: 'Followers List',
              },
              empty: {
                following: 'You are not following anyone yet.',
                followers: 'You have no followers yet.',
              },
              button: {
                unfollow: 'Unfollow',
                follow: 'Follow',
              },
            },
          }
        },
      backtest: {
        singleTicker: "Ticker",
        backtest: "Backtest",
        portfolio: "Portfolio",
        "challengeTopOnePercent": "Join the Top 1%",
        "period_cut_warning_dynamic": "The start period has been adjusted due to the late data start date of some symbols.",
        error: {
            dataMissingStrict: "⚠️ Data is insufficient for {{tickers}} during the selected period ({{startDate}} ~ {{endDate}}).",
            dataMissingStrict2: "⚠️ Data is insufficient for {{tickers}} during the selected period ({{customStart}} ~ {{customEnd}}).",
            dataMissingStrict3: "⚠️ Data is insufficient during the selected period ({{startDate}} ~ {{endDate}}).",
            invalidCustomDate: "Invalid date range.",
            checkInputsOrData:  "Please confirm the stock's listing date.",
            calculationFailed:  "Optimization failed",
        },
        "crisis": {
          "asiaRussia": "1998 Asia/Russia Financial Crisis (LTCM)",
          "dotcom": "2000-2002 Dot-com Bubble Burst",
          "gfc": "2007-2009 Global Financial Crisis (GFC)",
          "tradeWar": "2018 US-China Trade War & Rate Hike",
          "covid": "2020 COVID-19 Pandemic Crash",
          "inflation": "2022 Inflation & Rate Hike"
        },
        "historicalCrisisCheck": "Historical Crisis",
        "selectCrisisScenario": "Select a crisis scenario to simulate",
        "viewFullPeriod": "Full Period",
        
        backtestIntro: "Will my investment idea really work? Verify it with historical data and design your own successful investment.",
        enterOneTickerAndWeight: "You must enter at least one ticker and weight.",
        enterOneTickerAndWeightForBenchmark: "Please enter at least one ticker and weight (Benchmark).",
        TickerAndWeight: "Enter ticker and weight.",
        weightSumMustBe100: "The sum of the weights must be 100%.",
        notValidTicker: "This is not a valid ticker.",
        weightPlaceholder: "Weight (%)",
        resetButton: "Reset",
        notRecommendation:"",
        loadExamplesButton:"Load example",
        addTicker: "Add Ticker",
        totalWeight: "Total Weight",
        backtestPeriod: "Backtest Period",
        "1year": "1Y",
        "2years": "2Y",
        "3years": "3Y",
        "4years": "4Y",
        "5years": "5Y",
        "6years": "6Y",
        "7years": "7Y",
        "8years": "8Y",
        "9years": "9Y",
        "10years": "10Y",
        "20years": "20Y",
        "30years": "30Y",
        custom:"custom",
        startDate: "Start Date",
        endDate: "End Date",
        enterBenchmark: "Enter Benchmark",
        benchmarkExample: "e.g., ^GSPC, ^KS11",
        checkingTicker: "Checking ticker...",
        runBacktest: "Run Backtest",
        fetchErrorDetailed: "❌ An error occurred while fetching backtest data",
        loadingData: "Loading data...",
        fetchError: "An error occurred.",
        optimizedPortfolioError: "Optimized portfolio data not found.",
        noPortfolio: "No portfolio available.",
        BacktestTooltip: "Please enter the tooltip content here. (e.g., Backtest data is based on price data that considers market capitalization and liquidity.)",
        cumulativeReturn: "Cumulative Return",
        vsBenchmark: "vs Benchmark",
        individualStocks: "Individual",
        portfolioVsBenchmarkReturn: "Portfolio vs. Benchmark Return Change",
        date: "Date",
        individualStockCumulativeReturn: "Individual Portfolio Stock Cumulative Return",
        "rebalancePeriod": "Rebalancing Period",
        "none": "None",
          
        returnAnalysis: "Return Analysis",
        daily: "Daily",
        yearly: "Yearly",
        quarterly: "Quarterly",
        monthly: "Monthly",
        portfolioVsBenchmarkMonthlyReturn: "Portfolio vs. Benchmark Monthly Return",
        individualStockMonthlyReturn: "Individual Portfolio Stock Monthly Return",
        portfolioVsBenchmarkYearlyReturn: "Portfolio vs. Benchmark Yearly Return",
        year: "Year",
        individualStockYearlyReturn: "Individual Portfolio Stock Yearly Return",
        drawdown: "Maximum Drawdown",
        drawdownPercentage: "Drawdown (%)",
        portfolioVsBenchmarkMonthlyDrawdown: "Portfolio vs. Benchmark Monthly Max Drawdown",
        individualStockMonthlyDrawdown: "Individual Portfolio Stock Monthly Max Drawdown",
        portfolioVsBenchmarkYearlyDrawdown: "Portfolio vs. Benchmark Yearly Max Drawdown",
        individualStockYearlyDrawdown: "Individual Portfolio Stock Yearly Max Drawdown",
        Summary: "Summary",
        indicator: "Indicator",
        optimizedPortfolio: "Optimized Portfolio",
        benchmark: "Benchmark",
        annualVolatility: "Annual Volatility",
        maxDrawdown: "Max Drawdown",
        "sharpeRatio": "Sharpe Ratio",
        "sharpePerformancetable": "Excess return per unit of volatility. Higher values indicate better efficiency; 1.0+ is good, while 2.0+ is considered outstanding.",

        "calmarRatio": "Calmar Ratio",
        "calmarPerformancetable": "Annual return relative to Maximum Drawdown (MDD). Measures the balance between return and downside risk; 1.0–2.0+ is seen as highly stable.",

        "sortinoRatio": "Sortino Ratio",
        "sortinoPerformancetable": "Return relative to downside volatility only. Higher values indicate better protection against losses; 2.0+ is evaluated as an excellent strategy.",
        showExpertMetrics: "Show more",
        hideExpertMetrics: "Hide",

        mutualPerformance:"P vs B",
        differencePB: "P - B",
        differenceSB: "S - B",

        OneYearRolling: "1 Year",
        ThreeYearRolling: "3 Years",
        FiveYearRolling: "5 Years",
        periodReturns: "Calendar",
        rollingReturns: "Rolling",
        periodDrawdown: "Calendar",
        rollingDrawdown: "Rolling",
        rollingReturnCaption: "Trailing {{activeRollingPeriod}} return (daily rebalanced to initial weights)",
        rollingDrawdownCaption: "Trailing {{activeRollingDrawdownPeriod}} max drawdown (daily rebalanced to initial weights)",
        // rollingDrawdownCaption: "Max Drawdown over the trailing {{activeRollingDrawdownPeriod}} period ending on the displayed date.",
        // rollingReturnCaption: "Cumulative Return over the trailing {{activeRollingPeriod}} period ending on the displayed date.",

        loadMyPortfolioButton: "Load Portfolio",
        selectPortfolio: "Select a portfolio.",
        noPortfolios: "No saved portfolios.",
        portfolioLoaded: "{{name}} portfolio loaded. Now run the backtest.",
        portfolioLoadedSuccess: "Portfolio loaded successfully!",
        weightSumWarning: "The sum of weights in the loaded portfolio is {{sum}}%. Please adjust to 100% before running the backtest.",
        savePortfolioButton: "Save",
        startTracking: "Start Tracking",
        confirmResetTracking: "Delete the {{name}} portfolio and restart performance tracking from the current point? (Existing tracking data will be deleted)",
        trackingResetSuccess: "{{name}} Portfolio has been registered successfully.",
        saveSuccess: "Portfolio saved successfully.",
        benchmarkInvalidOnLoad: "The loaded benchmark is invalid. Please check and run again.",
        
        portfolioAllocationHistory : "Composition History",

        // 💡 2. 로딩 및 버튼 관련 추가
        loading: "Loading",
        close: "Close",
        private: "Private",
        public: "Public",
        
        // 💡 3. 오류 메시지 세분화 (코드에 사용된 toast/error 메시지)
        loadError: {
          loginRequired: "Login required.",
          fetchFailed: "Failed to fetch portfolio list.",
          emptyHoldings: "No valid holdings in the selected portfolio."
        },
        saveError: {
          loginRequired: "Login required.",
          enterOneTickerAndWeight: "Please enter at least one ticker and weight.",
          enterOneTickerAndWeightForBenchmark: "Please enter at least one ticker and weight (Benchmark)."
        },
        trackingResetError: {
          deleteFailed: "Failed to delete existing portfolio",
          createFailed: "Failed to create new portfolio",
          limitExceeded: "Exceeded portfolio creation limit"
        },
        // 💡 4. UI/UX 및 기타 메시지
        resetMessage: "Input has been reset.",
        customDateRange: "Custom Date Range",
        startDate: "Start Date",
        endDate: "End Date",
        shareLink: "Copy Share Link",
        loadExampleDisclaimer: "Example loaded. Run the backtest.",
        
        // 💡 5. Toast 메시지에 필요한 키 (Modal 파일에서 사용될 수 있음)
        linkCopied: "Share link copied.",
        newPortfolioModal: {
          loginRequiredTooltip: "Login required to save portfolio."
        },

        "improveTitle": "Boost Your Portfolio",
        "improveDesc": "Manage smarter with professional algorithms and analysis tools.",
        "allocTitle": "Find the Golden Ratio",
        "allocDesc": "Optimize weights to maximize your returns.",
        "corrTitle": "Check Stock Compatibility",
        "corrDesc": "Avoid over-concentration in similar assets.",
        "riskTitle": "Build a Loss Shield",
        "riskDesc": "Measure your resilience against market downturns.",
        "simTitle": "Success Probability",
        "simDesc": "Preview potential outcomes with virtual scenarios.",

         // 💡 성과 지표 관련 상세 설명 (툴팁용)
         // 💡 Performance Metrics (Tooltips)
        "winRate": "Win Rate",
        "winRateExplanation": "Percentage of profitable trading days. Higher values indicate more consistent returns.",
        
        "profitFactor": "Profit Factor (PF)",
        "profitFactorExplanation": "The ratio of gross profits to gross losses. A value above 1.0 means the strategy is profitable, and 1.5 or higher is generally considered excellent.",
        
        "ulcer": "Ulcer Index",
        "ulcerExplanation": "Quantifies psychological stress based on drawdown depth and duration. Below 5 is stable; 15+ indicates high risk and volatility.",

        "upi": "Ulcer Performance Index (UPI)",
        "upiExplanation": "Measures how rewarding the returns are relative to the stress (Ulcer Index). A higher value means better risk-adjusted returns; 1.0+ is efficient, and 2.0+ is considered outstanding.",
              
        "avgDrawdown": "Average Drawdown",
        "avgDrawdownExplanation": "The average depth of all declines from previous peaks.",
              // 💡 추가 UI 텍스트
        "indicator": "",
        "Portfolio": "Portfolio",
        "symbol": "Symbol",
        "maxDrawdown": "Maximum Drawdown",
        "cumulativeReturn": "Cumulative Return",
        "cagr": "CAGR",
        
        // 💡 전문가 모드 및 MDD 히스토리 관련
        "showExpertMetrics": "Show More",
        "hideExpertMetrics": "Hide",
        "mddHistoryShow": "Show Major Drawdown History",
        "mddHistoryHide": "Hide Drawdown History",
        "recovered": "Fully Recovered",
        "ongoing": "Recovering",
        "recoveryPeriod": "Recovery Period",
        "avgRecovery": "Avg. Recovery Period",
        "avgRecoveryExplanation": "The average number of calendar days taken to recover the previous peak after a drawdown begins.",
        "mddPeriodExplanation": "The total duration from the peak, through the trough, until full recovery to the previous high.",
        "tradingDays": "Trading Days",

        "strategy": "Portfolio",
        "benchmark": "Benchmark",
        "profitabilitySummary": "Performance",
        "riskManagement": "Risk",
        "diversificationRatio": "Diversification Ratio (DR)",
        //"diversificationExplanation": "Higher is better. It measures how effectively risk is spread by reducing correlations between assets. (>1.2 is excellent)",
        "diversificationExplanation": "Measure of portfolio efficiency. [1.0: None | 1.1-1.2: Average | 1.2-1.5: Good | 1.6+: Strong]",
        "collapse": "Collapse ▲",
        "history": "History ▼",
        "var95": "Daily Value at Risk (VaR 95%)",
        "varExplanation": "VaR (95%): The maximum potential loss expected 95% of the time under normal market conditions, excluding extreme tail risks.",
        "efficiency": "Efficiency",
        "expertViewLess": "🔍 Hide Risk Analysis ▲",
        "expertViewMore": "🔍 Advanced Risk Analysis ▼",
        "chart": "Chart",
        "table": "Table",
      },
      "loadExampleDisclaimer": "Loading example portfolio.",
      "linkCopied": "Link has been copied.",
      "preventDepletion": "prevent asset depletion",
      "scenarioCount": "{{count}} Scenarios",
      "balanceLabel": "Balance",
      "rangeLabel": "Range",
      "myPrincipal": "My Principal",
    "montecarlo": {
      "intro": "Is your retirement plan just a vague hope of 'it'll be fine'?",
      "introSub": "Test your plan against 10,000 market scenarios and discover your true 'probability' right now.",
      "mode": "Fund Management Goal",
      "modeAccumulate": "Grow Wealth",
      "modeWithdraw": "Live on Withdrawals",
      "duration": "Plan Duration",
      "durationUnit": "years",
      "simCount": "Analysis Precision",
      "simSpeed": {
        "fast": "Fast",
        "normal": "Normal",
        "precise": "Precise"
      },
      "currency": "Currency",
      "totalInvestment": "Current Total Assets",
      "monthlyCont": "Monthly Savings",
      "contIncreaseLabel": "Yearly Savings Increase (%)",
      "target": "Final Target Amount",
      "targetPlaceholder": "Target Amount",
      "withdrawalRateLabel": "First Year Withdrawal (%)",
      "inflationLabel": "Inflation Rate (%)",
      "inflationTooltip": "Simulates maintaining real purchasing power by increasing the withdrawal amount by the inflation rate each year.",
      "minSurvivalLabel": "Minimum Survival Target: ",
      "loadExample": "Load Example (VOO/BND)",
      "addTicker": "+ Add Ticker",
      "reset": "Reset",
      "loadMyPortfolio": "Load My Portfolio",
      "saveCurrentPortfolio": "Save Current Portfolio",
      "autoLoadExample": "No tickers entered. Running simulation with example data (VOO/BND).",
      "shareLink": "Share Results",
      "milestone": {
        "title": "📊 Projected Assets by Year",
        "fiveYear": "5-Year Intervals",
        "allYears": "All Years",
        "headers": {
          "year": "Year",
          "p10": "Bottom 10%",
          "median": "Median",
          "p90": "Top 10%",
          "survivalRate": "Survival Rate",
          "goalRate":"Goal Chance",
          "principal": "Principal"
        },
        "yearLabel": "Year {{year}}"
      },
      "kpi": {
        "survivalRate": "Survival Probability (Success Rate)",
        "survivalRateSub": "Asset depletion prevention for {{years}} years",
        "ruinYear": "Projected Depletion Point",
        "ruinYearSub": {
          "safe": "✓ Survived",
          "depleted": "⚠ Depleted in {{year}} years"
        },
        "ruinYearSafe": "Safe ✓",
        "ruinYearAfter": "After {{year}} years",
        "maxDrawdown": "Maximum Asset Drawdown",
        "maxDrawdownSub": "Bottom 10%: -{{value}}%",
        "goalRate": "Goal Achievement Rate",
        "goalRateSub": "Target: {{amount}}{{currency}}",
        "projectedAssets": "Projected Assets After {{years}} Years",
        "projectedAssetsSub": "Bottom 10%: {{amount}}{{currency}}"
      },
      "chart": {
        "growthTitle": "Growth Simulation",
        "finalDistTitle": "Final Asset Distribution",
        "mddTitle": "Maximum Asset Drawdown",
        "present": "Present",
        "afterYears": "{{year}} years later",
        "tooltipGrowth": "Randomly combines historical data to simulate thousands of futures. A model where monthly savings/withdrawals are reflected at compound interest.",
        "tooltipDrawdown": "Real experienced drawdown, including asset decreases from living expenses and market drops.",
        "tooltipFinalBalance": "Reflects compounding for each monthly contribution at the time of investment."
      },
      "dataInfo": {
        "description": "1. Calculated based on common dates across all selected items. Dates with no data are excluded.\n2. Uses adjusted closing prices reflecting total returns assuming dividend reinvestment."
      },
      "percentileLabels": {
        "p10low": "Bottom 10%",
        "p50": "Median",
        "p90high": "Top 10%",
        "p10upper": "Upper 10%",
        "p10lower": "Lower 10%",
        "range80": "80% Probability Range"
      },
      "histogramFilter": {
        "showAll": "Show All",
        "realisticRange": "Realistic Range Only"
      },
      "frequencyLabel": "Frequency",
      "withdrawalSetting": "Withdrawal Settings",
      "withdrawalModeRate": "Percentage (%)",
      "withdrawalModeAmount": "Amount (Monthly)",
      "withdrawalPlaceholder": "Enter monthly spending",
      "perMonth": "mo",
      "annual": "Annual",
      "annualWithdrawal": "Annual withdrawal: {{amount}} {{currency}}",
      "annualRate": "({{rate}}% annually)",
      "monthlyAvailable": "Approx. {{amount}} {{currency}} available / month",
      "unitYear": "yr"

      },
      "sentiment": {
          "title": "Market Sentiment",
          "subTitle": "Real-time news analysis & market drivers.",
          "ticker": "Ticker",
          "topic": "Topic",
          "searchTickerPlaceholder": "Ticker (e.g. AAPL)",
          "searchTopicPlaceholder": "Topic (e.g. Inflation)",
          "analyze": "Analyze",
          "sentimentTrend": "Sentiment Trend",
          "relationshipMap": "Relationship Map",
          "relatedStocks": "Related Stocks",
          "keyTopics": "Key Topics",
          "stocks": "STOCKS",
          "topics": "TOPICS",
          "newsOnDate": "News on {{date}}",
          "realTimeFeed": "Real-time Feed",
          "resetFilter": "Reset Filter",
          "newsCount": "{{count}} items",
          "positive": "Positive",
          "negative": "Negative",
          "neutral": "Neutral",
          "aiSummaryStatus": "<strong>{{target}}</strong> Sentiment is <span style='color: {{color}}; font-weight: 700;'>{{label}}</span>.",
          "aiSummaryDetail": "Driven by <strong>{{topics}}</strong>.",
          "upwardMomentum": " Showing strong upward momentum.",
          "marketCaution": " Market caution is advised.",
          "relatedAssets": "Related Assets"
        },
      "common": {
        "period": {
          "years":"years",
          "custom":"custom",
          "used": "Analysis Period Used",
          "min_years_recommend": "Minimum 5 years recommended",
          "short_period_warning": "⚠️ Reliability may be low as the period is less than 5 years."
        },
        "settings":{
          "dataPeriod": "Past Data Period",
          "dataPeriod2": "Past Data Period",
          "years":"Y"
        },

        "days": {
          "unit": "Days",
          "total": "Common Trading Days",
          "min_returns": "252"
        }
      }
    }

  },
  ko: {
    translation: {
      promptLogin: "로그인이 필요합니다.",
      shareLink: "결과 공유",
      clipboardNotSupported: "클립보드 API를 지원하지 않는 브라우저입니다. URL을 직접 복사해주세요.",
      Insights: "인사이트",
      checkingTicker: "종목 코드 확인 중...",
      portfolioList:"포트폴리오",
      linkCopied:"링크가 성공적으로 복사되었습니다!",
      portfolioOptimizationTools:"최적화 도구",
      showExpertMetrics: "더보기",
      hideExpertMetrics: "숨기기",

      loadExampleDisclaimer:"예시로 제시된 종목들은 임의로 선정된 것이며, 투자 권유나 추천이 아님을 알려드립니다.",
      assetAllocationCalculator: "📊 자산배분",
      exampleHint: "처음이신가요? 예시로 시작해보세요!",
      loadExample: "예시 종목 불러오기",
      riskCalculation: "⚠️ 리스크 시뮬레이션",
      discussion: "토론방",
      footer: "제공되는 금융 데이터는 오류·지연이 있을 수 있으며 정확성을 보장하지 않습니다. 모든 투자 손실 책임은 본인에게 있으며, 본 사이트는 투자권유 목적이 아닙니다. [개인정보처리방침] 본 사이트는 서비스 최적화를 위해 Google Analytics를 사용하며 브라우저에서 쿠키 수집을 차단할 수 있습니다.",
      allocIntroMain:"종목 코드만 입력하면 자동으로 포트폴리오 완성",
      allocIntroSub:"주식·채권·금·암호화폐 등 자산 추가 → 전략 선택 → 최적 비중 자동 계산",
      enterticker: "종목코드 입력",
      slectAlloc: "시작하기",
      optimalallocation: "📌 최적 자산 비중",
      backtestresult: "📊 과거검증 결과",
      notValidTicker: "죄송합니다. 이 종목은 현재 데이터 제공이 어렵습니다.",
      dataLoadingCalculatiing: "📊 데이터 로딩 및 계산 중...",
      short:"공매도",
      backtestPeriod:"📅 과거검증 기간:",
      dobacktest:"📊 과거검증\n(백테스트)",
      year: "년",
      selectAllocMethod: "자산배분 전략 선택",
      minVarButtonDesc: "✅ 안전한 투자",
      riskPartiyButtonDesc: "⚖️ 균형 잡힌 투자",
      blackLittermanButtonDesc: "🌍 시장 흐름 반영",
      maxSharpeButtonDesc: "🚀 최고의 수익",
      openExplanation: "설명 보기",
      closeExplanation: "설명 닫기",
      dataperiod: "데이터 기간:",
      allowshort: "공매도\n허용",
      AdvancedSetting: "고급\n설정",
      riskfreerate: "무위험 금리(%) ",
      riskfreerateExplanation: "무위험 금리는 원금 손실 위험이 없는 가장 안전한 투자에서 기대할 수 있는 수익률을 의미합니다. 일반적으로 국채(예: 미국 국채, 한국 국고채) 등의 이자율이 사용됩니다.",
      enterExpectedReturn: "예상 수익률을 입력해 보세요",
      enterExpectedReturnExplanationBL: "입력하지 않은 종목은 시장 기대수익률로 계산됩니다.",
      enterExpectedReturnExplanationMaxSharpe: "값을 입력하지 않으면, 과거 데이터가 예상 수익률로 사용됩니다.",
      enterExpectedReturnExample:"예: 5%" ,
      warning1moreTicker: "📢 최소 1개 이상의 종목을 입력해야 합니다!",
      warningTooManyTicker:"⚠️ 너무 많은 종목을 입력하면 계산 속도가 느려질 수 있습니다.",
      DoassetAllocation:"📊 최적 자산배분 실행",
      minVarExplanation: "리스크(위험)를 가장 낮추는 투자 방식입니다. 변동성이 적은 자산을 중심으로 포트폴리오를 구성하여, 안정적인 수익을 목표로 합니다.",
      riskPartiyExplanation: "모든 자산이 비슷한 위험을 가지도록 균형 있게 배분하는 방식입니다. 특정 자산에 쏠리지 않도록 설계되었습니다.",
      blackLittermanExplanation: "시장 정보를 반영하여 포트폴리오를 최적화하는 방식입니다. 투자자의 의견을 입력 할 때 균형 잡힌 배분을 제공합니다.",
      maxSharpeExplanation: "위험 대비 최대한 높은 수익을 목표로 하는 투자 방식입니다. 변동성이 크지만 장기적으로 높은 기대 수익을 제공합니다.",
      sharpePerformancetable: 
      "변동성 대비 초과 수익.\n" +
      "≥ 1.0 (우수)\n" +
      "≤ 0.5 (안 좋음)",
      calmarPerformancetable: 
        "연간 수익률 대비 최대 낙폭.\n" +
        "≥ 0.5 (우수)\n" +
        "≤ 0.2 (위험)",
    
      sortinoPerformancetable: 
        "하락 리스크만 고려한 수익.\n" +
        "≥ 1.0 (우수)\n" +
        "≤ 0.5 (안 좋음)",
      indicator: "📌 지표",
      equalAllocation: "⚖️ 균등분배",
      optimizedPortfolio: "✅ 최적화된 포트폴리오",
      Portfolio: "✅ 포트폴리오",
      benchmark: "📈 벤치마크",

      cumulativeReturn: "누적 수익률",
      cagr: "연평균 성장률 (CAGR)",
      annualVolatility: "연간 변동성",
      maxDrawdown: "최대 낙폭 (MDD)",
      sharpeRatio: "샤프 비율",
      calmarRatio: "칼마 비율",
      sortinoRatio: "소르티노 비율",

      sharpeRatioTooltip: "샤프 비율 설명 보기",
      calmarRatioTooltip: "칼마 비율 설명 보기",
      sortinoRatioTooltip: "소르티노 비율 설명 보기",


      BacktestTooltip: "1. 선택된 모든 항목의 공통된 날짜를 기준으로 계산했습니다. 이 때문에 데이터가 없는 날짜는 계산에서 제외됩니다.\n2. 조정 종가를 사용해 배당금 재투자를 가정한 총 수익률을 반영했습니다.",

      
      ///
      accumlatedReturn:"누적 수익률",
      
      extendedDescriptions: {
        minVar: {
          title: "📌 최소 분산 포트폴리오란?",
          p1: "투자에서 가장 중요한 목표 중 하나는 <bold>위험(변동성)을 최소화하면서 수익을 얻는 것</bold>입니다.",
          p2: "최소 분산 포트폴리오는 평균-분산 최적화에서 <bold>가장 낮은 변동성</bold>을 가지는 포트폴리오로, 리스크 대비 안정적인 투자 수익을 추구하는 투자자에게 적합합니다.",
          visualTitle: "📊 MVP의 시각적 설명",
          visualDesc: "아래 그래프는 <bold>효율적 프론티어(Efficient Frontier)</bold> 상에서 최소 분산 포트폴리오를 표시한 것입니다.",
          bullet1: "🔵 <bold>파란색 곡선</bold>: 효율적 프론티어 (다양한 자산 비율 조합에 따른 위험과 기대 수익률 간의 최적 관계)",
          bullet2: "🔴 <bold>붉은 점</bold>: 최소 분산 포트폴리오 (가장 낮은 변동성을 가지는 포트폴리오)",
          altImg: "효율적 프론티어 그래프",
          mathTitle: "📌 최소 분산 포트폴리오의 수학적 모델",
          mathP1: "포트폴리오의 기대 수익률 ",
          mathP2: "과 분산 ",
          mathP3: "은 다음과 같이 정의됩니다:",
          returnTitle: "① 포트폴리오 기대 수익률",
          varianceTitle: "② 포트폴리오 분산",
          objectiveTitle: "③ 최적 비중을 구하는 목적 함수",
          subjectTo: "subject to:"
        },
        riskParity: {
          title: "📌 리스크 패리티(Risk Parity)란?",
          p1: "리스크 패리티 전략은 <bold>각 자산이 포트폴리오의 전체 위험에 동일한 기여</bold>를 하도록 자산을 배분하는 방식입니다.",
          p2: "특히 <bold>저변동성 자산의 비중을 높이고, 고변동성 자산의 비중을 낮춰</bold> 보다 안정적인 포트폴리오 구성을 목표로 합니다.",
          conceptTitle: "📌 리스크 패리티의 핵심 개념",
          bullet1: "✅ <bold>각 자산의 위험 기여도를 동일하게 조정</bold>",
          bullet2: "✅ <bold>변동성이 높은 자산의 비중은 줄이고, 낮은 자산의 비중은 늘림</bold>",
          bullet3: "✅ 기대 수익률 추정 없이 포트폴리오 구성으로 <bold>예측 오류에 강함</bold>",
          mathTitle: "📌 수학적 모델 개요",
          rcTitle: "① 각 자산의 위험 기여도(Risk Contribution)",
          rcP1: "각 자산 ",
          rcP2: "의 위험 기여도 (",
          rcP3: ")는 다음과 같이 정의됩니다:",
          rcP4: "여기서 ",
          rcP5: "는 포트폴리오 전체 변동성에 기여하는 절대적 값입니다. 이를 비율로 나타내기 위해 포트폴리오 전체 변동성 ",
          rcP6: "로 정규화합니다.",
          rcP7: "아래 리스트는 각 항목의 의미를 설명합니다:",
          rcList1: "자산 i의 포트폴리오 비중",
          rcList2: "자산들의 공분산 행렬",
          rcList3: "자산 i의 포트폴리오 변동성 기여도",
          rcList4: "포트폴리오 전체 변동성 (σₚ = √(wᵀΣw))",
          conditionTitle: "② 리스크 패리티 조건",
          conditionP1: "모든 자산의 위험 기여도가 동일하도록 최적화됩니다.",
          conditionP2: "즉, 비율로 표현하면:",
          optimalTitle: "③ 최적 포트폴리오 비중",
          optimalP1: "최적의 비중 (w*)은 다음 최적화 문제를 통해 도출됩니다:",
          optimalP2: "",
          subjectTo: "subject to:",
          rcP8: "여기서 ",
          rcP9: "는 포트폴리오 전체 변동성을 나타내며, ",
          rcP10: "는 동일합니다.",
          advantagesTitle: "📌 리스크 패리티의 장점",
          advantages: [
            "✅ <bold>안정적인 포트폴리오</bold>: 고변동성 자산에 의존하지 않고 균형 잡힌 투자 가능",
            "✅ <bold>수익률 예측 불필요</bold>: 변동성만 고려하여 자산 배분",
            "✅ <bold>시장 충격에 강함</bold>: 특정 자산군 급락 시에도 전체 포트폴리오 영향 제한"
          ]
        },
        maxSharpe: {
          title: "📌 최대 샤프 비율 포트폴리오란?",
          p1: "샤프 비율은 포트폴리오의 <bold>초과 수익률을 변동성으로 조정한 값</bold>입니다.",
          p2: "최대 샤프 비율 포트폴리오는 <bold>위험 대비 가장 높은 기대 수익</bold>을 제공하여, <bold>투자자들이 효율적으로 위험을 감수하면서 높은 수익</bold>을 얻을 수 있도록 최적화됩니다.",
          visualTitle: "📊 MSR의 시각적 설명",
          visualDesc: "아래 그래프에서 <bold>최대 샤프 비율 포트폴리오</bold>의 위치를 확인할 수 있습니다.",
          bullet1: "🔵 <bold>파란색 곡선</bold>: 효율적 프론티어 (다양한 자산 비율 조합에 따른 위험과 기대 수익률 간의 최적 관계)",
          bullet2: "🌟 <bold>별</bold>: 최대 샤프 비율 포트폴리오 (가장 높은 위험 조정 수익률을 가지는 포트폴리오)",
          altImg: "최대 샤프 비율 포트폴리오 그래프",
          mathTitle: "📌 최대 샤프 비율 포트폴리오의 수학적 모델",
          sharpeFormulaTitle: "① 샤프 비율 공식",
          sharpeFormula: "S(w) = \\frac{E(R_p) - R_f}{\\sigma_p}",
          sharpeFormulaDesc: "여기서:",
          sharpeDescList: [
            "E(R_p): 포트폴리오 기대 수익률",
            "R_f: 무위험 수익률",
            "σ_p: 포트폴리오 변동성"
          ],
          objectiveTitle: "② 최적 비중을 구하는 목적 함수",
          subjectTo: "subject to:",
          subjectFormula: "\\sum_{i=1}^{n} w_i = 1",
          rcList1:" 포트폴리오 기대 수익률",
          rcList2:" 무위험 수익률",
          rcList3:" 포트폴리오 변동성",

        },
        blackLiterman: {
          title: "📌 블랙-리터만 모델이란?",
          p1: "블랙-리터만 모델은 투자자들이 <bold>자신만의 시장 전망(Views)을 반영하면서도 기존의 시장 균형(시장 포트폴리오)에 기반한 자산 배분을 할 수 있도록</bold> 설계된 포트폴리오 최적화 모델입니다.",
          p2: "전통적인 평균-분산 접근법은 투자자의 기대 수익률 추정치에 민감하지만, 이 모델은 <bold>베이즈 통계 개념</bold>을 적용하여 시장 정보와 투자자의 주관적 견해를 결합, 보다 안정적인 포트폴리오를 생성합니다.",
          marketTitle: "📌 시장 균형 수익률",
          marketDesc: "먼저, 시장 자본화 비중 등을 바탕으로 암묵적 균형 수익률(Implied Equilibrium Returns, π)을 산출합니다.",
          afterPi: "",
          marketWhere: "여기서:",
          lambdaDesc: "투자자의 위험 회피 계수. 일반적으로 λ = (E(R_mkt) - R_f) / σ_mkt²로 계산되며, E(R_mkt)는 시장 기대 수익률, R_f는 무위험 수익률, σ_mkt²는 시장 분산입니다.",
          sigmaDesc: "자산 간 공분산 행렬",
          wmktDesc: "시장 자본화 비중",
          viewsTitle: "📌 투자자의 견해 반영",
          viewsDesc: "투자자는 특정 자산에 대해 <bold>자신만의 전망(Views)을 제시할 수 있습니다.</bold>",
          blpExpectedReturn: "블랙-리터만 모델은 이러한 견해를 반영하여 새로운 기대 수익률 ",
          blpExpectedReturnAfter: "을 도출합니다.",
          bayesianTitle: "📌 베이지안 통합",
          bayesianDesc: "블랙-리터만 모델은 <bold>베이지안 접근법</bold>을 활용하여, <bold>시장 균형 수익률과 투자자의 주관적 견해를 통합</bold>합니다.이를 통해 보다 안정적이고 현실적인 기대 수익률 벡터 E[R]를 계산하고, 이를 기반으로 최적 포트폴리오 비중을 결정합니다.",
          mathTitle: "📌 수학적 모델 개요",
          expectedReturnTitle: "① 투자자 견해 반영 후의 기대 수익률",
          afterExpectedReturn: "",
          tauDesc: "시장 공분산 행렬에 대한 스케일링 파라미터",
          PDesc: "투자자 견해를 표현하는 행렬 (특정 자산에 대한 견해 반영)",
          omegaDesc: "견해의 불확실성을 나타내는 공분산 행렬",
          QDesc: "투자자가 기대하는 수익률(견해 벡터)",
          optimalTitle: "② 최적 포트폴리오 비중",
          blpOptimalDesc: "새로운 기대 수익률을 기반으로 투자자의 효용을 극대화하는 포트폴리오 비중 ",
          blpOptimalAfter: "을 도출합니다.",
          optimalFormula: "w^* = \\frac{1}{\\lambda} \\Sigma^{-1} E[R]",
          advantagesTitle: "📌 블랙-리터만 모델의 장점",
          advantages: [
            "✅ <bold>안정성</bold>: 시장 균형 수익률을 기본으로 극단적인 포트폴리오 비중을 방지",
            "✅ <bold>투자자 견해 반영</bold>: 개별 투자자의 전망을 반영하여 맞춤형 포트폴리오 구성 가능",
            "✅ <bold>현실적인 포트폴리오 구성</bold>: 시장 정보를 고려하여 균형 잡힌 투자 비중 도출"
          ]
        }
      },
      analysisPastDataBased: "과거 데이터 기반 분석",
      downloadMarketData: "📥 시장 데이터 다운로드 ",
      dataSource: "데이터 출처:",

      downloadLimitWarning: "⚠️ 다운로드는 10분에 한 번만 가능합니다. 잠시 후 다시 시도해 주세요.",
      downloadInProgress: "📥 CSV 파일을 준비 중입니다. 다운로드가 완료되면 알림이 표시됩니다!",
      downloadComplete: "✅ CSV 파일 다운로드가 완료되었습니다!",
      downloadError: "❌ CSV 다운로드 중 오류가 발생했습니다. 다시 시도해 주세요.",
      confirmBrowserNotice: "카카오톡에서는 다운로드가 원활하지 않을 수 있습니다.\n다른 브라우저를 이용하는 것이 좋습니다.\n\n계속 진행하시겠습니까?",
      downloadInProgressAlert: "⚠️ CSV 파일이 다운로드 중입니다. 잠시만 기다려 주세요.",
      loadingData: "📊 데이터를 로딩 중입니다...",
      fetchError: "❌ 데이터를 불러오는 중 문제가 발생했습니다. 잠시 후 다시 시도하거나, 웹사이트를 새로고침해 주세요.",
      noPortfolio: "포트폴리오 종목을 입력해주세요.",
      equalPortfolioError: "Equal Weighted 포트폴리오 데이터를 불러오는 중 오류 발생",
      optimizedPortfolioError: "최적화된 포트폴리오 데이터를 불러오는 중 오류 발생",


      addedTicker: ": 이미 추가된 종목입니다",

      "LoginPromtToast": {
        "required_message":"로그인이 필요합니다.",
        "google_notice": "인앱 브라우저(카카오톡 등)에서는 구글 로그인이 어려울 수 있습니다.",
        "backtest": {
          "title": "더 깊이 있는 분석을 위해 기간을 확장해 보세요.",
          "description1": "10년 초과 분석은 회원 전용 서비스입니다.",
          "description2": "로그인 시 <strong>최대 30년까지 무료 분석</strong>을 계속하실 수 있습니다.",
          "browser_notice": "* 인앱 브라우저(카카오톡 등)에서는 구글 로그인이 제한될 수 있습니다.",
          "button": "로그인 후 계속하기"
        }
      },
      
      // --- 추가: Risk 컴포넌트 관련 번역 ---
      risk: {
        // 인트로 문구
        intro: "내 포트폴리오 손실, 감당할 수 있을까?",
        introSub: "과거 데이터와 통계 분포를 바탕으로, 최대 손실 가능성을 확인해보세요.",
        // 용어사전 토글 버튼 (확정 전: "용어사전 ▼", 확정 후: "▲ 닫기")
        toggleExplanation: {
          open: "용어사전 ▼",
          close: "▲ 닫기"
        },
        // VaR 관련
        var: {
          definition: "VaR (Value at Risk)",
          explanation: "일정 신뢰구간에서 예측되는 최대 손실을 의미합니다. 예: 히스토리컬 VaR이 -5%라면, 하루 손실이 -5%를 넘을 확률이 (1 - 신뢰구간) 수준이라는 뜻입니다."
        },
        historicalVaR: {
          definition: "히스토리컬 VaR",
          explanation: "과거 실제 수익률 데이터를 기반으로 계산한 VaR입니다. 과거 수익률을 크기순으로 나열한 뒤, 설정된 신뢰구간에 따라 손실 하위 구간의 경계값을 VaR로 설정합니다.",
          title: "⏰ 히스토리컬 VaR",
          description: "과거 데이터를 기반으로, {{period}} 손실이 위 금액을 초과할 확률이 {{percent}}%입니다."
        },
        parametricVaR: {
          definition: "파라메트릭 VaR",
          explanation: "수익률이 정규분포를 따른다고 가정하여 계산한 이론적 VaR입니다. 실제 데이터가 정규분포에서 많이 벗어난다면, 히스토리컬 VaR과 차이가 클 수 있습니다.",
          title: "📈 파라메트릭 VaR",
          description: "정규분포를 가정할 때, {{period}} 손실이 위 금액을 초과할 확률이 {{percent}}%입니다."
        },

        // 위험 기여도 (Risk Contribution)
        riskContribution: {
          title: "종목별 위험 기여도",
          subtitle: "포트폴리오 총 VaR에 대한 각 종목의 기여도 (음수는 위험 분산 효과)",
          chartTitle: "위험 기여도"
        },
        
        // 주변 VaR (Marginal VaR)
        marginalVaR: {
          title: "손실 기여도 분석",
          subtitle: "특정 종목의 비중을 조절했을 때 포트폴리오 총 위험의 예상 변화량",
          recommendation: "위험 감소 경로",
          change1pct: "1% 비중 축소 시 위험 변화",
          recommend: {
            reduce: "축소",
            maintain: "확대",
            neutral: "유지"
          },
          explain: {
            reduce: "총 위험을 줄일 수 있음",
            maintain: "위험 분산 효과 있음",
            neutral: "영향이 미미함"
          }
        },
        
        // What-If 시뮬레이션
        whatIf: {
          change: "비중 변화 시뮬레이션",
          result: "예상 VaR 변화",
          changeLabel: "총 비중 변화",
          resultLabel: "총 위험 변화"
        },

        adddedTicker:"는 이미 추가된 종목입니다.",
        confidenceInterval: {
          definition: "신뢰구간",
          explanation: "예를 들어 신뢰구간 95%는 하루 손실이 VaR 값을 초과할 확률이 5%라는 의미입니다. 신뢰구간이 높을수록 VaR 값(예상 손실)은 더 커져 보수적으로 계산됩니다."
        },
        settings: {
          title: "주요 설정",
          dataPeriod: "데이터 기간:",
          year: "년",
          confidence: "신뢰구간:"
        },
        portfolioInput: {
          title: "포트폴리오 입력",
          selectCurrency: "통화 선택:",
          instruction: "종목코드와 비중을 입력해주세요",
          confirm: "확정",
          edit: "수정",
          delete: "삭제",
          addTicker: "+ 종목 추가",
          calculate: "계산하기",
          totalInvestment: "투자 금액",
          totalWeight: "총 비중",
        },
        alerts: {
          noConfirmed: "확정된 종목이 없습니다. 종목을 선택해주세요.",
          zeroInvestment: "총 투자 금액이 0입니다. 금액을 입력해주세요.",
          noTicker: "종목 코드를 입력해주세요.",
          noAmount: "금액을 입력해주세요.",
          noTickersOrWeights: "종목코드와 비중을 올바르게 입력해주세요.",
          totalWeightNot100: "총 비중이 100%가 아닙니다(현재: {{sum}}%). 다시 확인해주세요.",
          invalidTotalInvestment: "총 투자 금액이 유효하지 않습니다. 양수(0보다 큰 수)를 입력해주세요.",
          dataError: "데이터를 불러오는 중 오류가 발생했습니다."
        },
        "period": {
          "d": "일별",
          "w": "주별 (롤링)",
          "m": "월별 (롤링)",
          "q": "분기별 (롤링)",
          "a": "연간 (롤링)",
          "daily": "일별",
          "weekly": "주별",
          "monthly": "월별",
          "quarterly": "분기별",
          "annual": "연간"
        },

        chart: {
          "title": {
            "daily": "일별 수익률 분포", // (원할 경우 "하루 수익률 분포"로 사용 가능)
            "weekly": "주별 수익률 분포",
            "monthly": "월별 수익률 분포",
            "quarterly": "분기별 수익률 분포",
            "annual": "연별 수익률 분포" // '연별수익률 분포'에서 띄어쓰기 수정 권장
          },
          "xaxis": {
            "daily": "하루 수익률",
            "weekly": "주별 롤링 수익률",
            "monthly": "월별 롤링 수익률",
            "quarterly": "분기별 롤링 수익률",
            "annual": "연별 롤링 수익률"
          },
          subtitle: "({{start}} ~ {{end}})"
        },
        plot: {
          upperHistorical: "상위 ({{confidence}}%) 과거 수익률",
          lowerHistorical: "하위 ({{confidenceComplement}}%) 과거 수익률",
          upperParametric: "상위 ({{confidence}}%) 정규분포 추정 수익률",
          lowerParametric: "하위 ({{confidenceComplement}}%) 정규분포 추정 수익률",
          title: "과거분포 & 정규분포 추정",
          xaxis: "하루 수익률(%)",
          yaxis: "빈도 (거래일 수)"
        },
        placeholder: {
          KRW: "예시: 1000원",
          USD: "예시: 1000$",
          EUR: "예시: 1000€"
        },
        "ticker": "종목",
        "currentWeight": "현재 비중",
        "total": "합계",
        "sim_assumption": "💡 전체 비중 축소는 현금 전환, 증가는 차입 가정. (100 bp = 1%)",
        "riskContribution_absolute": "기여도 절대값 (%)",
        "max_minimize": "최대 축소"
      },

    diversification: "📋 종목 리스트 분석기"
    
    ,
    correlation: {
      introMain: "내가 고른 종목, 진짜 잘 나눠졌을까?",
      introSub: "종목이 많아도 움직임이 같으면 위험해요. 포트폴리오를 진단하고 개선해보세요!",
      resultTitle: "종목 간 관계 분석",
      calculate: "분석하기",
      alerts: {
        minStocks: "최소 3개 이상의 종목을 선택해주세요.",
        invalidDateRange: "시작일이 종료일보다 클 수 없습니다.",
        fetchError: "선택 기간 내 모든 종목 데이터가 존재하는지 확인하십시오."
      },
      analysisPeriod: {
        title: "📅 분석 기간",
        periodRange: "{{startDate}} ~ {{endDate}} ({{dayCount}}일)",
        tooltip: "이 기간은 모든 선택 종목에 공통적으로 존재하는 날짜를 의미합니다. 데이터 누락이 있을 경우 분석 결과에 영향을 미칠 수 있습니다."
      },
      day: "일",
      analysis: {
        highCorrCombinationTitle: "🔺 위험 집중 경고: 움직임이 매우 비슷한 종목 조합 (0.7 이상):",
        highCorrWarning: "🔺 아래 조합은 '도플갱어'처럼 움직입니다. 종목은 다르지만 투자 결과는 하나를 산 것과 비슷하여 위험이 특정 그룹에 쏠려 있습니다.",
        correlationListTitle: "📊 종목 조합:",
        groupHeader: "📌 {{group}}",
        highCorrPairItem: "  - {{other}}",
        noHighCorr: "✅ 닮은꼴 조합 없음: 모든 종목이 1:1로 비교했을 때 서로 중복되지 않는 개성을 가지고 있습니다.",
        lowCorrAssetsTitle: "🔹 포트폴리오 안정에 기여하는 종목: (다른 종목들과 따로 움직이는 종목)",
        lowCorrAssetItem: "- {{asset}}",
        allAssetsCorrelated: "⚠️ 방어주 부재: 하락장에서 혼자 버텨줄 '독자적인' 성격의 자산을 추가하여 안정성을 높여보세요."
      },
      cluster: {
        group: "그룹 {{group}}",
        groupCount: "그룹 수",
        description: "지정한 그룹수에 따라 가장 유사한 종목들을 분류"
      },
      scatter: {
        perfectPositive: "상관계수 1 (완전 양의 상관관계)",
        perfectPositiveTitle: "상관계수 1",
        positive07: "상관계수 0.7 (양의 상관관계)",
        positive07Title: "상관계수 0.7",
        uncorrelated: "상관계수 0 (상관관계 없음)",
        uncorrelatedTitle: "상관계수 0",
        negative07: "상관계수 -0.7 (음의 상관관계)",
        negative07Title: "-0.7 (역방향)",
        perfectNegative: "상관계수 -1 (완전 음의 상관관계)",
        perfectNegativeTitle: "-1 (반대 방향)",
        axisX: "X",
        axisY: "Y"
      },
      pca: {
        title2D: "종목 간 흐름 분석 (2D) - 주요 흐름 1 ({{exp1}}%) vs 주요 흐름 2 ({{exp2}}%)",
        title3D: "종목 간 흐름 분석 (3D) - 주요 흐름 1, 2, 3",
        axisX: "주요 흐름 1 ({{exp}}% 반영)",
        axisY: "주요 흐름 2 ({{exp}}%)",
        axisZ: "주요 흐름 3 ({{exp}}%)",
        buttons: {
          "2d": "2D 보기",
          "3d": "3D 보기"
        },
        explanation: {
          main: "가까이 뭉친 종목은 '한 패거리'이며, 멀리 떨어질수록 서로의 하락을 보완합니다. (전체 움직임의 약 <bold>{{value}}</bold>가 이 차트에 반영됨)",
          note: "종목 간 거리가 멀수록 분산 투자 효과가 커집니다."
        }
      },
      diagnosis: {
        title: "포트폴리오 체력 진단",
        marketRiskExposure: "■ 주력 흐름 의존도: {{exposure}}%", // 결과: 얼마나 한 몸인가
        diversificationBalanceScore: "■ 테마 쏠림 방어력: {{score}} / 10", // 구조: 특정 패거리가 너무 큰가 (머릿수)
        correlationSpreadScore: "■ 종목 간 독립성 점수: {{score}} / 10" // 자질: 1:1로 봤을 때 서로 다른가
      },
      interpretation: {
        marketRiskExposure: {
          low: "종목들이 제각각 움직입니다. 특정 테마나 시장 뉴스에 전체가 한꺼번에 휘둘리지 않는 건강한 상태입니다.",
          medium: "적절히 조화롭습니다. 큰 흐름을 타면서도 개별 종목들의 특징이 수익률에 잘 반영됩니다.",
          high: "일체화 수준이 매우 높습니다. 종목은 여러 개지만 실제로는 거대한 한 덩어리처럼 움직이고 있어 위험합니다."
        },
        diversificationBalance: {
          low: "특정 테마 쏠림 🚨: 비슷한 성격의 종목이 너무 많이 모여 있습니다. 특정 그룹의 영향력이 너무 커서 포트폴리오 전체의 운명이 그들에게 좌우되고 있습니다.",
          medium: "주의 필요: 일부 독립적인 종목들이 섞여 있으나, 여전히 특정 테마 그룹의 영향력이 포트폴리오의 절반 이상을 차지합니다.",
          high: "균형 우수 👍: 어느 한 테마가 포트폴리오를 독점하지 않도록 종목들이 여러 그룹으로 고르게 잘 구성되어 있습니다."
        },
        correlationSpread: {
          low: "보완 관계 부재: 종목들을 1:1로 비교했을 때 너무 비슷하게 움직입니다. 하락장에서 서로를 지켜주는 효과를 기대하기 어렵습니다.",
          medium: "보통 수준: 종목 간 성격 차이가 어느 정도 존재합니다. 움직임이 아예 다른 종목을 한두 개 더 추가하면 좋습니다.",
          mediumPlus: "꽤 좋음: 종목 간 독립성이 어느정도 보장되어 있습니다.",
          high: "최고 수준 🏆: 종목 간 1:1 관계가 매우 희박합니다!"
        }
      },
      heatmap: {
        hide: "숨기기",
        show: "종목 관계 보기",
        title: "상관관계 히트맵",
        explanation: "빨간색일수록 비슷하게 움직이고, 파란색일수록 반대로 움직여요. 노란색은 서로 상관없이 개별적으로 움직임을 의미합니다."
      },
      similarityAnalysis: {
        title: "종목 움직임 그룹화",
        cluster: {
          groupCount: "분류 그룹 수",
          description: "유사하게 움직이는 종목들을 지정한 개수만큼의 그룹으로 묶어 분석합니다."
        }
      },
      explanation: {
        title: "상관관계란?",
        desc: "여러 종목의 가격이 서로 얼마나 비슷하게 혹은 다르게 움직이는지를 통계적으로 나타낸 지표입니다."
      },
      risk: {
        toggleExplanation: {
          open: "진단 결과 해석 보기",
          close: "해석 닫기"
        }
      },
      loadExample: "예제 불러오기",
      enterticker: "종목 코드를 입력하세요",
      resetStocks: "종목 초기화",
      dateRange: {
        sixM: "6개월",
        oneY: "1년",
        twoY: "2년",
        threeY: "3년",
        fourY: "4년",
        fiveY: "5년",
        sixY: "6년",
        sevenY: "7년",
        eightY: "8년",
        nineY: "9년",
        tenY: "10년",
        twentyY: "20년",
        thirtyY: "30년",
        max: "전체",
        custom: "직접 선택"
      },
      viewDetail: "세부 진단 보기",
      groupSimilarity: "종목 그룹 분석"
    },
    
    "loadExampleDisclaimer": "예시 포트폴리오를 로드합니다.",
    "linkCopied": "링크가 복사되었습니다.",
    "preventDepletion": "자산 고갈 방지",
    "scenarioCount": "{{count}}가지 시나리오",
    "balanceLabel": "잔고",
    "rangeLabel": "범위",
    "myPrincipal": "내가 넣은 돈",
    
    "montecarlo": {
        "intro": "은퇴 계획, '괜찮겠지'라는 막연한 기대뿐인가요?",
        "introSub": "1만 번의 시나리오 시뮬레이션으로 미리 확인하고 대비하세요.",
        "mode": "자금 관리 목적",
        "modeAccumulate": "자산 키우기",
        "modeWithdraw": "생활비로 쓰기",
        "duration": "계획 기간",
        "durationUnit": "년",
        "simCount": "분석 정밀도",
        "simSpeed": {
            "fast": "빠름",
            "normal": "보통",
            "precise": "정밀"
        },
        "currency": "사용 화폐",
        "totalInvestment": "현재 총 자산",
        "monthlyCont": "매달 추가 저축",
        "contIncreaseLabel": "연간 증액률(%)",
        "target": "최종 목표 금액",
        "targetPlaceholder": "목표 금액",
        "withdrawalRateLabel": "첫 해 인출(%) 자산 대비",
        "inflationLabel": "물가 상승(%)",
        "inflationTooltip": "매년 물가 상승률만큼 인출액(생활비)을 증액하여 실질적인 구매력을 유지하도록 시뮬레이션에 반영합니다.",
        "minSurvivalLabel": "최소 생존 목표:",
        "loadExample": "예시 로드 (VOO/BND)",
        "addTicker": "+ 종목 추가",
        "reset": "초기화",
        "loadMyPortfolio": "내 포트폴리오 불러오기",
        "saveCurrentPortfolio": "현재 구성 저장",
        "autoLoadExample": "입력된 종목이 없어 예시 데이터(VOO/BND)로 시뮬레이션을 실행합니다.",
        "shareLink": "결과 공유하기",
        "milestone": {
            "title": "연도별 예상 자산",
            "fiveYear": "5년 단위",
            "allYears": "전체 연도",
            "headers": {
                "year": "연도",
                "p10": "하위 10%",
                "median": "중간값",
                "p90": "상위 10%",
                "survivalRate": "생존률 (Survival Rate)",
                "goalRate":"목표 달성률",
                "principal": "원금"
            },
            "yearLabel": "{{year}}년차"
        },
        "kpi": {
            "survivalRate": "생존 확률 (Success Rate)",
            "survivalRateSub": "{{years}}년간 자산 고갈 방지",
            "ruinYear": "예상 고갈 시점",
            "ruinYearSub": {
                "safe": "✓ 생존",
                "depleted": "⚠ {{year}}년 후 고갈"
            },
            "ruinYearSafe": "Safe ✓",
            "ruinYearAfter": "{{year}}년 후",
            "maxDrawdown": "최대 자산 하락폭",
            "maxDrawdownSub": "하위 10%: -{{value}}%",
            "goalRate": "목표 달성률",
            "goalRateSub": "목표: {{amount}}{{currency}}",
            "projectedAssets": "{{years}}년 후 예상 자산",
            "projectedAssetsSub": "하위 10%: {{amount}}{{currency}}"
        },
        "chart": {
            "growthTitle": "성장 시뮬레이션",
            "finalDistTitle": "최종 자산 분포",
            "mddTitle": "최대 자산 하락폭",
            "present": "현재",
            "afterYears": "{{year}}년 후",
            "tooltipGrowth": "과거 데이터를 무작위로 조합해 수천 가지 미래를 시뮬레이션합니다. 매월 저축·인출하는 금액이 자산 흐름에 복리로 반영되는 모델입니다.",
            "tooltipDrawdown": "시장 하락뿐만 아니라 '생활비 인출'로 인해 자산이 줄어드는 모든 구간을 포함하여 계산된 실제 체감 낙폭입니다.",
            "tooltipFinalBalance": "단순 연말 합산이 아닌, 매월 적립금이 투입될 때마다 해당 시점의 수익률이 복리로 반영된 정밀 시뮬레이션 결과입니다."
        },
        "dataInfo": {
            "description": "1. 선택된 모든 항목의 공통된 날짜를 기준으로 계산했습니다. 이 때문에 데이터가 없는 날짜는 계산에서 제외됩니다.\n2. 조정 종가를 사용해 배당금 재투자를 가정한 총 수익률을 반영했습니다."
        },
        "percentileLabels": {
            "p10low": "하위 10%",
            "p50": "중간",
            "p90high": "상위 10%",
            "p10upper": "상위 10%",
            "p10lower": "하위 10%",
            "range80": "80% 확률 구간"
        },
        "histogramFilter": {
            "showAll": "전체 보기",
            "realisticRange": "현실 범위만"
        },
        "frequencyLabel": "횟수",
        "withdrawalSetting": "생활비 설정",
        "withdrawalModeRate": "비율 (%)",
        "withdrawalModeAmount": "금액 (월)",
        "withdrawalPlaceholder": "월 생활비 입력",
        "perMonth": "월",
        "annual": "연",
        "annualWithdrawal": "연간 {{amount}} {{currency}} 인출",
        "annualRate": "(연 {{rate}}%)",
        "monthlyAvailable": "매월 약 {{amount}} {{currency}} 사용 가능",
        "unitYear": "연",
    },

  "sentiment": {
    "title": "시장 감정 분석",
    "subTitle": "실시간 뉴스 분석 및 시장 동인 파악",
    "ticker": "티커",
    "topic": "주제",
    "searchTickerPlaceholder": "티커 입력 (예: AAPL)",
    "searchTopicPlaceholder": "주제 입력 (예: Inflation)",
    "analyze": "분석",
    "sentimentTrend": "감정 트렌드",
    "relationshipMap": "관계도",
    "relatedStocks": "관련 종목",
    "keyTopics": "주요 키워드",
    "stocks": "종목",
    "topics": "키워드",
    "newsOnDate": "{{date}} 뉴스",
    "realTimeFeed": "실시간 피드",
    "resetFilter": "필터 초기화",
    "newsCount": "{{count}}개 항목",
    "positive": "긍정적",
    "negative": "부정적",
    "neutral": "중립적",
    "aiSummaryStatus": "<strong>{{target}}</strong>의 감정은 <span style='color: {{color}}; font-weight: 700;'>{{label}}</span> 상태입니다.",
    "aiSummaryDetail": "<strong>{{topics}}</strong>에 의해 주도되고 있습니다.",
    "upwardMomentum": " 강력한 상승 모멘텀을 보이고 있습니다.",
    "marketCaution": " 시장 주의가 필요합니다.",
    "relatedAssets": "관련 자산"
  },




 "common": {
    "period": {
      "years":"년",
      "custom":"직접 입력",
      "used": "분석 사용 기간",
      "min_years_recommend": "최소 5년 이상 권장",
      "short_period_warning": "⚠️ 5년 미만이므로 결과의 신뢰도가 낮을 수 있습니다."
    },
     "settings":{
          "dataPeriod": "데이터 기간",
          "dataPeriod2": "과거 데이터 기간",
          "years":"년"
        },
    "days": {
      "unit": "일", 
      "total": "공통 거래일 수",
      "min_returns": "252"
    }
  },
      navPage: {
        hero: {
          title: "당신의 투자 전략, 과거에도 통했을까요?",
          subtitle: "30년 치 데이터를 통해 당신의 포트폴리오가 시장을 이길 수 있는지 10초 만에 검증하세요.",
          button: "지금 바로 백테스트 시작하기"
        },

        expertTools: {
          label: "포트폴리오 최적화 도구"
        },

        quickActions: {
         "group": {
            "label": "포트폴리오 최적화",
            "alloc": "자산 배분",
            "risk": "위험 분석",
            "corr": "조합 분석",
            "backtest": "백테스트",
            "sim": "성공 확률",
            "sentiment": "시장 심리" 
          },
          "group2": {
            "label": "포트폴리오 최적화",
            "alloc": "📊 자산 배분",
            "risk": "⚠️ 위험 분석",
            "corr": "📋 조합 분석",
            "backtest": "🔄️ 백테스트",
            "sim": "🎲 성공 확률",
            "sentiment": "💡 시장 심리"
          },
          ranking: "포트폴리오 랭킹",
          insight: "투자 인사이트",
          ranking2: "🏆 포트폴리오 랭킹",
          insight2: "📖 투자 인사이트",
        },
        topPortfolios: {
          title: "Top Portfolios",
          subtitle: "다양한 기준에서 뛰어난 투자 전략들을 살펴보세요",
          empty: "로딩 중..."
        },
        "period": {
          "recent30Days": "최근 30일"
        },
        sort: {
          return: "수익률",
          sharpe: "샤프 비율",
          mdd: "MDD",
          calmar: "칼마 비율",
          volatility: "변동성"
        },
        metric: {
          return: "수익률",
          sharpe: "샤프 비율",
          mdd: "최대 낙폭",
          calmar: "칼마 비율",
          volatility: "변동성"
        },
        daysActive: "{{days}}일 활동",
        viewAllPortfolios: "전체 포트폴리오 보기",
        latestInsights: {
          title: "최신 인사이트",
          subtitle: "성공적인 투자 여정을 위한 분석과 지식을 얻어가세요",
          empty: "첫 인사이트를 남겨보세요"
        },
        sharpeInfo: "샤프 지수는 포트폴리오의 '위험 대비 수익률'을 나타냅니다. 지수가 높을수록, 감수한 위험에 비해 더 나은 성과를 냈다는 뜻입니다.",
        calmarInfo: "칼마 비율은 '최대 하락에 대한 복구 능력'을 보여줍니다. 지수가 높을수록 손실을 빠르게 회복하고 안정적인 수익을 냈음을 의미합니다.",
        defaultAuthor: "QuanPort 팀",
        viewAllPosts: "전체 인사이트 둘러보기"
      }
      ,
      announcementPopup: {
        newFeaturesTitle: "QuanPort에 새로운 기능이 추가되었어요!",
        subtitle: "더 강력해진 기능으로 당신의 투자 경험을 한 단계 업그레이드하세요.",
        portfolioAnalysisTitle: "포트폴리오 분석",
        portfolioAnalysisDesc: "나만의 포트폴리오를 등록하고 성과를 정밀하게 분석하세요.",
        shareInsightsTitle: "인사이트 공유",
        shareInsightsDesc: "당신의 투자 노하우를 공유하고 영향력을 확장하세요.",
        visionText: "QuanPort는 창작자들을 위한 지속 가능한 성장 모델을 구축하고자 합니다.",
        futurePlanText: "향후 프리미엄 구독 도입을 통해, 당신의 인사이트가 수익으로 이어지는 환경을 만들 계획입니다.",
        dontShowToday: "일주일간 보지 않기",
        close: "닫기"
        // [추가된 부분] 서버 과부하/증설 팝업 전용 키
        ,serverError: {
            title: "폭발적인 관심에 감사드립니다! 🔥",
            subtitle: "현재 예상보다 훨씬 많은 분들이<br/>포트폴리오 최적화 서비스를 찾아주고 계십니다.",
            statusTitle: "시스템 긴급 증설 작업 중",
            statusDesc: "안정적인 서비스 제공을 위해 서버 용량을 2배로 늘리고 있습니다.<br/><strong>포트폴리오 최적화 기능</strong>이 잠시 지연될 수 있습니다.",
            waitTitle: "조금만 기다려주세요",
            waitDesc: "작업이 완료되는 대로 더 빨라진 속도로 보답하겠습니다.",
            otherFeaturesTitle: "다른 기능은 정상 이용 가능",
            otherFeaturesDesc: "최적화 외의 시장 분석 및 인사이트 기능은 정상적으로 이용 가능합니다.",
            dontShowToday: "오늘 하루 보지 않기",
            buttonText: "조금 이따 다시 올게요!"
        }
      }
      ,
       postDetail: {
        loading: "로딩중…",
        error: "게시물을 불러오는 데 실패했습니다.",
        notFound: "게시물을 찾을 수 없습니다.",
        unknownUser: "알 수 없는 사용자",
        goBack: "뒤로 가기",
        navigateToAuthorPageTitle: "{{nickname}}님의 마이페이지로 이동",
        profileAlt: "{{nickname}} 프로필",
        unfollow: "언팔로우",
        follow: "팔로우",
        following: "팔로잉",
        removeSavedTitle: "나중에 읽기 목록에서 제거",
        saveTitle: "나중에 읽기",
        saved: "저장됨",
        save: "저장",
        alreadyLikedTitle: "이미 좋아요를 눌렀습니다",
        like: "좋아요",
        likeCountText: "{{count}}개 좋아요"
      }
      ,
      postLists: {
        searchPlaceholder: "게시글 검색...",
        loadingInitial: "게시글 리스트를 불러오는 중...",
        loadingMore: "불러오는 중...",
        loadingFailed: "게시글 로딩 실패: {{message}}",
        filteredByAuthor: "{{nickname}}의 게시글",
        clearFilter: "필터 해제",
        noPosts: "첫 게시글을 남겨보세요",
        endOfPosts: "더 이상 게시글이 없습니다.",
        topPortfoliosTitle: "📈 TOP 10 포트폴리오",
        topPortfoliosByCategory: "📈 TOP 10 포트폴리오",
        categoryReturn: "최고 수익률",
        categorySharpe: "최고 샤프 지수",
        categoryVolatility: "최저 변동성",
        noPortfoliosInCategory: "30일 운용일 이상 포트폴리오가 없습니다.",
        unnamedPortfolio: "이름 없는 포트폴리오",
        profileAlt: "{{nickname}}님의 프로필",
        likes: "좋아요",
        comments: "댓글",
        date: "날짜"
      }
      ,
      tagInput: {
        maxTagsPlaceholder: "최대 {{count}}개의 태그",
        removeTagButton: "태그 제거"
      },
      writePost: {
        button: "인사이트",
        cancel: "취소",
        confirm: "확인",
        loginRequiredTooltip: "로그인 후 이용 가능합니다.",
        fetchError: "게시글을 불러오는데 실패했습니다: {{message}}",
        imageSizeError: "이미지 크기가 {{max_size}}MB를 초과합니다.",
        loginRequired: "로그인이 필요합니다.",
        updateFailed: "글 수정에 실패했습니다: {{message}}",
        submitFailed: "글 작성에 실패했습니다: {{message}}",
        titlePlaceholder: "제목을 입력하세요",
        contentPlaceholder: "내용을 입력하거나 붙여넣으세요…",
        authChecking: "인증 확인 중...",
        processing: "처리 중...",
        editPost: "글 수정",
        submitPost: "글 등록",
        modalEditTitle: "게시글 수정",
        modalSettingsTitle: "게시글 설정",
        previewPlaceholder: "미리보기 내용을 입력하세요",
        tagsPlaceholder: "태그를 입력하세요",
        uploading: "업로드 중...",
        uploadPreviewImage: "미리보기 이미지 업로드",
        previewUploadError: "미리보기 이미지 업로드에 실패했습니다: {{message}}",
        remove: "제거",
        paidPost: "구독자 전용 글",
        // comingSoon: "구독자 전용 글 기능은 제공될 예정입니다. 작성자는 월 1$에서 100$ 사이에서 구독료를 자유롭게 설정할 수 있습니다.",
        comingSoon: "작성자 보상 시스템이 준비 중입니다. 현재 모든 인사이트는 무료로 제공됩니다. 작성자님들의 노고에 보답하기 위해 광고 수익 공유 시스템을 도입하여 수익을 배분하는 방안을 검토 중입니다.",
        titleRequired: "게시물 제목을 입력해 주세요.",
        contentRequired: "게시물 내용을 입력해 주세요."
      },
      portfolios: {
        pageTitle:"모든 포트폴리오",
        title: "모든 포트폴리오",
        toast: {
          creationSuccess: "포트폴리오가 성공적으로 생성되었습니다! 🚀\n\n수익률은 포트폴리오 내 모든 종목의 가장 최근 종가를 기준으로 계산됩니다.\n\n참고: 시장이 열려있는 동안 포트폴리오를 생성하면 당일 종가로, 시장이 닫혀있을 경우 직전 거래일 종가로 계산이 시작됩니다."
        },
        loadingInitial: "포트폴리오를 불러오는 중…",
        title: "🏆 포트폴리오 랭킹",
        updateInfo: "업데이트 시간: 매일 09:00",
        "liveTab": "🚀 오늘의 랭킹",
        "fameTab": "👑 명예의 전당",
        "fame": {
          "selectionCriteria": "선정 기준",
          "selectionValue": "수익률·샤프지수·MDD 중 상위 10% 이내 기록",
          "update": "업데이트",
          "updateValue": "매일 09:00 (KST), 매주 금요일 성적 마감",
          "ranking": "순위 산정",
          "rankingValue": "입성 그룹 내 상대 순위 (동률 시 수익률 우선)"
        },

        emptyList: "첫 포트폴리오를 등록해 보세요.",
        lockedTooltip: "21 거래일이 지나야 계산 결과가 표시됩니다.",
        tableHeaders: {
          user: "사용자",
          portfolio: "포트폴리오",
          return: "수익률",
          maxDrawdown: "최대 낙폭",
          volatility: "변동성",
          sharpe: "샤프지수",
          sortino: "소르티노",
          calmar: "칼마비율",
          days: "운용일"
        },
        period: {
          all: "전체",
        },
        unit: {
          days: "일"
        },
        viewButton: "보기",
        tableUpdating: "포트폴리오 목록을 업데이트 중…",
        loadingMore: "더 많은 포트폴리오를 불러오는 중…",
        createButton: "내 포트폴리오 만들기",
        createButton2: "포트폴리오 등록",
        createButton3: "내 포트폴리오 시작하기",
        createButton4: "성과 추적 시작하기",
        createButton5: "포트폴리오 저장하기",
        loginRequiredTooltip: "로그인이 필요합니다",
        unnamed: "Unnamed",
        successMessage:"포트폴리오가 성공적으로 등록되었습니다!",
        tooltip: {
          return: "선택한 기간 동안의 수익률입니다.",
          maxDrawdown: "선택한 기간 동안의 최고점 대비 최대 하락폭입니다.",
          volatility: "가격 변동의 표준편차입니다.",
          sharpe: "위험 대비 수익률(효율성) 지표입니다.",
          sortino: "하락 위험만 고려한 위험 대비 수익률입니다.",
          calmar: "연평균 수익률을 최대 낙폭으로 나눈 값입니다."
        }
      },

      portfolioCreated:"포트폴리오가 성공적으로 등록되었습니다!",
      portfolioDetail: {
        loading: "로딩중…",
        error: "오류: ",
        title: "🏆 포트폴리오 랭킹",
        ownerDescription: "포트폴리오 생성자",
        visitPageButton: "페이지 방문 ↗️",
        followButton: "팔로우",
        followingButton: "팔로잉",
        calculationExplanationTitle: "수익률 계산 방식",
        calculationExplanationToggle: {
          open: "해석 보기",
          close: "해석 닫기"
        },
        calculationExplanationText: {
          p1: "시장이 닫힌 경우 (주말 등) 가장 최근의 **종가**를 시작 가격으로, 시장이 열린 날에는 장 마감 **종가**를 기준으로 계산합니다.",
          p2: "포트폴리오에 포함된 주식들의 시장 마감 시간이 다른 경우, 모든 시장이 마감된 후에 수익률 계산을 시작합니다.",
          p3: "배당금 재투자를 가정하며, 주가 변동 외 배당금 지급을 고려한 **'조정 종가'**를 사용해 계산됩니다.",
        },
        compositionTitle: "📊 현재 종목 비중",
        compositionHistoryTitle: "🗓️ 종목 비중 변화",
        compositionHistoryToggle: {
          open: "종목 비중 변화",
          close: "종목 비중 변화"
        },
        cumulativeValueTitle: "📊 누적 가치",
        drawdownTitle: "📉 Drawdown 추이",
        commentSectionTitle: "댓글",
        unnamed: "Unnamed",
        noData: {
          title: "포트폴리오 수익률 계산 안내",
          mainMessage: "투자 데이터는 포트폴리오 생성 후 <1>2거래일 뒤</1>부터 확인하실 수 있습니다.",
          calculationBasis: "계산 기준:",
          adjustedClosingPrice: "마지막 거래일의 조정 종가",
          dataUpdate: "데이터 업데이트:",
          dailyUpdateTime: "매일 오전 9시",
          tradingDayTitle: "시장이 열려있을 때",
          tradingDayExample: "수요일 장중에 생성 → <1>금요일 오전 9시</1>부터 확인 가능",
          tradingDayExplanation: "(수요일과 목요일 종가 비교 후)",
          nonTradingDayTitle: "시장이 닫혀있을 때",
          nonTradingDayExample: "토요일에 생성 → <1>화요일 오전 9시</1>부터 확인 가능",
          nonTradingDayExplanation: "(금요일과 월요일 종가 비교 후)"
        },
        // --- PortfolioRadarChart.js 에서 사용되는 항목 추가 ---
        "performanceRadarTitle": "📈 상대 성과",
        "tooltipTitle": "지표 상세 설명",
        "referenceLine": "50% 기준선",
        "percentile": "백분위 점수",
        "percentileScore": "백분위 점수",
        "noPeriodData": "최소 운용일을 충족하지 못했습니다.", // "최소 운용일이 {{period}}을 충족하지 못했습니다.",
        "radarCaption": "각 지표는 지난 {{period}} 동안 동종 포트폴리오 및 벤치마크 대비 백분위 점수입니다.",
        "radarBenchmarkTip": "50% 기준선: 모든 포트폴리오 및 벤치마크의 중앙값입니다.",
        "tooltips": {
          "return": "동일 기간 수익률의 백분위 점수",
          "sharpe": "위험 대비 수익률(효율성) 점수",
          "calmar": "최대 낙폭 대비 수익률 점수",
          "stability": "변동성이 낮을수록 높음",
          "defense": "최대 낙폭(MDD)이 적을수록 높음"
        },
        // --- [중요] metrics가 portfolioDetail 안에 중첩됨 ---
        "metrics": {
          "return": "수익률",
          "sharpe": "샤프",
          "calmar": "칼마",
          "stability": "안정성", 
          "defense": "방어력"      
        },
        
        // --- [중요] periods가 portfolioDetail 안에 중첩됨 ---
        "periods": {
          "1w":"1W",
          "2w":"2W",
          "1m": "1M",
          "3m": "3M",
          "6m": "6M",
          "1y": "1Y",
          "2y": "2Y",
          "3y": "3Y"
        },

        // ✨ [추가] 요약 섹션 제목 및 키 메트릭
        "summaryTitle": "요약", 
        "elapsedDaysInfo": "운용일: {{days}}일",
        "totalReturn": "총 수익률",
        "mdd": "최대 낙폭 (MDD)",
        "sharpe": "샤프 비율",
        "volatility": "변동성",

        // ⭐ MISSING KEY 2: Analysis Mode Tabs (1. 추가된 키)
        "analysisMode": {
          "return": "수익 (기여도)",
          "risk": "위험 (변동성)", 
          "defense": "방어 (MDD)" 
        },
        
        "attributionInsight": {
            "returnBest": "이(가) 수익을 견인했고,",
            "returnWorst": "이(가) 가장 큰 손실을 냈습니다.",
            "riskWorst": "이(가) 변동성을 키웠지만,",
            "riskBest": "이(가) 포트폴리오를 안정화했습니다.",
            "defenseWorst": "이(가) 하락폭을 키웠고,",
            "defenseBest": "이(가) 하락장에서 잘 버텼습니다."
        },

        // ✨ [추가] 토글 버튼의 제목
        "attributionToggleTitle": "성과 기여도 분석",
        "attributionTitle": "📈 종목별 기여도", 
        "timeSeriesToggleTitle": "수익률 및 낙폭 추이",
        "attributionInsight": {
        "returnBest": "이(가) 수익을 견인했고,",
        "returnWorst": "이(가) 가장 큰 손실을 냈습니다.",
        "riskWorst": "이(가) 변동성을 키웠지만,",
        "riskBest": "이(가) 포트폴리오를 안정화했습니다.",
        "defenseWorst": "이(가) 하락폭을 키웠고,",
        "defenseBest": "이(가) 하락장에서 잘 버텼습니다."
        },
    
        // ✨ [신규] 툴팁 텍스트 키
        "attributionTooltip": {
            "good": "Good 👍",
            "bad": "Bad 👎",
            "avgWeight": "평균 비중",
            "return": "수익률",
            "volatility": "변동성",
            "mdd": "MDD",
            "contribution": "기여도"
        },
        "tab": {
          "Holdings": "보유 종목",
          "PerformanceTrend": "성과 추이"
        }
        
      }
      ,
      newPortfolioModal: {
     
        trackPortfolio: "성과 추적하기",
        confirmButton: "확인",
        modalMessage: {
          loginRequired: "포트폴리오를 생성하려면 로그인이 필요합니다.",
          enterName: "포트폴리오 이름을 입력해주세요.",
          enterTicker: "모든 종목에 티커를 입력해주세요. 비중이 있는 종목은 티커가 필수입니다.",
          totalWeight: "총 비중은 100%여야 합니다.",
          creationSuccess: "포트폴리오가 성공적으로 생성되었습니다!",
          creationError: "포트폴리오 생성 중 오류가 발생했습니다.",
          serverError: "포트폴리오 생성 실패.",
          limitExceededPublic:"공개 포트폴리오 최대 생성 한도(3개)를 초과했습니다. (성과 추적 3개, 개인 저장용 10개)",
          limitExceededPrivate: "개인 포트폴리오 최대 생성 한도(10개)를 초과했습니다. (성과 추적 3개, 개인 저장용 10개)",
        },
        title: "➕ 포트폴리오 생성",
        portfolioNameLabel: "포트폴리오 이름",
        portfolioNamePlaceholder: "예: 은퇴 자금 포트폴리오",
        loginRequiredTooltip: "로그인 후 이용 가능합니다.",
        tableHeaders: {
          ticker: "종목",
          weight: "비중 (%)",
        },
        totalWeightLabel: "총 비중:",
        weightWarning: "(총 비중이 100%가 아닙니다!)",
        addHolding: "종목 추가",
        createButton: "생성",
        deleteButton: "보유 종목 삭제",
      }
      ,
      rebalanceModal: {
        loading:"로딩 중...",
        title: "🔄 포트폴리오 재구성",
        totalWeightLabel: "총 비중:",
        addHoldingButton: "종목 추가",
        executeButton: "리밸런스 실행",
        loginRequiredTooltip: "로그인 후 이용 가능합니다.",
        alert: {
          confirm: "확인",
          totalWeight100: "총 비중이 100%가 되어야 합니다.",
          loginRequired: "로그인이 필요합니다.",
          permissionError: "이 포트폴리오를 리밸런스할 권한이 없습니다.",
          notFoundError: "포트폴리오를 찾을 수 없습니다.",
          generalError: "리밸런스 중 오류가 발생했습니다.",
        },
      }
      ,
      userPage: {
        loadingUser: "사용자 정보를 불러오는 중…",
        userNotFound: "사용자를 찾을 수 없습니다.",
        loadingError: "사용자 프로필 로딩에 실패했습니다.",
        unknownUser: "알 수 없는 사용자",
        portfolioLoadError: "포트폴리오를 불러오는 데 실패했습니다.",
        followerLoadError: "팔로우/팔로워 목록 로딩에 실패했습니다.",
        followLoginRequired: "팔로우하려면 로그인해야 합니다.",
        followSelf: "자기 자신은 팔로우할 수 없습니다.",
        followSuccess: "{{nickname}}님을 팔로우합니다.",
        followFailed: "팔로우 실패: {{error}}",
        unfollowConfirm: "{{nickname}}님을 언팔로우하시겠습니까?",
        unfollowFailed: "언팔로우 실패: {{error}}",
        tabPosts: "홈",
        tabAbout: "About",
        aboutTitle: "About",
        noIntroduction: "작성된 소개가 없습니다.",
        investmentResults: "투자 성과",
        loadingPortfolios: "로딩 중…",
        noPortfolios: "등록된 포트폴리오가 없습니다.",
        avg1YReturn: "평균 1년 수익률:",
        avg1YSharpe: "평균 1년 샤프지수:",
        portfolioTableTitle: "포트폴리오 ({{count}})",
        tableHeaderName: "포트폴리오 이름",
        tableHeaderReturn: "1Y Return",
        tableHeaderSharpe: "1Y Sharpe Ratio",
        tableHeaderDuration: "경과일",
        day: "{{count}}일",
        unnamed: "이름 없음",
        followingTitle: "팔로잉 ({{count}})",
        followerTitle: "팔로워 ({{count}})",
        noFollowing: "아직 팔로우하는 사람이 없습니다.",
        noFollowers: "아직 팔로워가 없습니다.",
        confirmButton: "확인",
        cancelButton: "취소",
        unfollowButton: "팔로잉",
        followButton: "팔로우",
        unfollowBtnAria: "{{nickname}}님 언팔로우",
        followBtnAria: "{{nickname}}님 팔로우",
        profileImageAlt: "{{nickname}}의 프로필 사진",
        userPageTitle: "사용자 페이지",
        "hallOfFame": "🏆 명예의 전당",
        "topPerformance": "최고 성과 기록",
        "trackRecords": "운용 기록",
        "latestAchievement": "최근 주요 성과",
        "metrics": {
          "return1Y": "수익률 (1년)",
          "sharpe": "샤프 지수",
          "yieldMaster": "수익률 마스터",
          "stabilityPro": "안정성 전문가",
          "defenseExpert": "방어 전문가",
          "topRank": "{{label}} Top {{rank}}"
        },

        userPostsList: {
          loadingPosts: "게시글을 불러오는 중…",
          loadingMore: "추가 게시글 로딩 중...",
          loadingError: "게시글 로딩 실패:",
          noPosts: "작성한 글이 없습니다.",
          endOfPosts: "더 이상 게시글이 없습니다.",
          postCount: "{{nickname}}님이 쓴 글 ({{count}})",
        },
      },
      signInPage: {
        loadingMessage: "로그인 중…",
      },
      setNicknamePage: {
        title: "닉네임 설정",
        introText: "서비스 이용을 위해 닉네임을 설정해주세요.",
        label: "닉네임",
        placeholder: "닉네임 입력 (최대 10자)",
        errorNicknameRequired: "닉네임을 입력해주세요.",
        alertSuccess: "닉네임이 성공적으로 설정되었습니다!",
        errorFailed: "닉네임 설정에 실패했습니다.",
        errorNetwork: "네트워크 오류가 발생했습니다.",
        successMessage: "닉네임 설정 완료!",
        buttonText: "설정",
      },
      loginComponent: {
        loading: "불러오는 중…",
        login: "로그인",
        logout: "로그아웃",
      },
      footerComponent: {
        feedbackButton: "버그 리포트 / 건의 사항",
        alertSuccess: "메시지가 성공적으로 전송되었습니다!",
        alertFailure: "메시지 전송에 실패했습니다. 다시 시도해 주세요.",
        modalTitle: "메시지 보내기",
        modalPlaceholder: "문제점이나 개선 방향을 자세히 설명해주세요. 상세한 내용은 빠른 피드백 반영에 큰 도움이 됩니다.",
        sendButton: "전송",
        closeButton: "닫기",
      }
      ,
      commentSection: {
        title: "💬 댓글",
        empty: "첫 댓글을 남겨 보세요." ,
        placeholder: {
          newComment: "댓글을 입력하세요...",
          username: "닉네임을 입력하세요",
          password: "비밀번호",
          reply: "답글을 입력하세요",
        },
        button: {
          submit: "댓글 등록",
          submitting: "등록 중…",
          reply: "답글",
          edit: "수정",
          delete: "삭제",
          save: "저장",
          cancel: "취소",
          showReplies: "답글 {{count}}개 보기",
          hideReplies: "답글 숨기기",
        },
        info: {
          loadingAuth: "인증 정보를 불러오는 중...",
          loggedInAs: "답글 작성: {{username}}",
          anonymousUser: "로그인 사용자",
          confirmDelete: "정말 삭제하시겠습니까?",
        },
        errors: {
          noTarget: "댓글을 작성할 대상이 지정되지 않았습니다.",
          noReplyTarget: "답글을 작성할 대상이 지정되지 않았습니다.",
          noEditTarget: "댓글을 수정할 대상이 지정되지 않았습니다.",
          noDeleteTarget: "댓글을 삭제할 대상이 지정되지 않았습니다.",
          commentRequired: "댓글 내용을 입력하세요.",
          allFieldsRequired: "닉네임, 댓글 내용, 비밀번호를 모두 입력하세요.",
          replyRequired: "답글 내용을 입력해주세요.",
          replyFieldsRequired: "닉네임과 비밀번호를 모두 입력해주세요.",
          editTextRequired: "수정할 텍스트를 입력하세요.",
          passwordRequired: "비밀번호를 입력하세요.",
          authRequired: "댓글을 수정하려면 로그인해야 합니다.",
          fetchFailed: "댓글 불러오기 실패",
          submitFailed: "댓글 등록 실패",
          replyFailed: "답글 등록 실패",
          editFailed: "수정 실패",
          deleteFailed: "삭제 실패",
          networkError: "네트워크 오류가 발생했습니다: ",
        },
      },
      auth: {
        loading: "인증 정보를 확인 중입니다...",
        error: "인증 중 오류가 발생했습니다.",
        errorCheckingNickname: "닉네임 확인 중 오류가 발생했습니다.",
        redirecting: "페이지를 이동 중입니다...",
      },
    mypage: {
        profile: '프로필',
        portfolio: '포트폴리오',
        posts: '포스트',
        confirm0: '확인',
        cancel: '취소',

        loading: {
          generic: '로딩 중…',
        },

        // 온보딩 섹션
        onboardingTitle: '✨ 당신의 금융 DNA를 완성하세요',
        onboardingText: '금융 DNA를 작성하면, <1>더 정확한 포트폴리오 분석</1>과 <1>취향에 맞는 콘텐츠</1>를 추천받을 수 있습니다.',
        getStarted: '지금 바로 시작하기',

        // 팔로우 섹션
        loadingFollows: '팔로우 정보 로딩 중...',
        following: '팔로잉',
        followers: '팔로워',

        // 포트폴리오 섹션
        noPortfolioRegistered: '등록된 포트폴리오가 없습니다.',
        avg1yReturn: '평균 1Y 수익률',
        avg1ySharpe: '평균 1Y 샤프 지수',
        name: '이름',
        elapsedDays: '운용일',
        dateSuffix: '일',
        rebalance: '재구성',
        delete: '삭제',
        registerNewPortfolio: '새 포트폴리오 등록',
        unnamedPortfolio: '이름 없음',
        table: {
          ret1y: '1Y RET',
          sr1y: '1Y SR',
        },

        // 🚨 누락된 포트폴리오 섹션 키 추가 🚨
        publicTrackingPortfolios: '추적 중',
        noAllPortfolios: '성과 추적 중인 포트폴리오가 없습니다.',
        privateArchivedPortfolios: '보관함',
        noPrivatePortfolios: '현재 개인 보관된 포트폴리오가 없습니다.',
        actions: '관리', 

        // 포스트 섹션
        // i18next 복수형 처리를 위한 키:
        followedPosts_one: '팔로우 포스트',
        followedPosts_other: '팔로우 포스트',
        myPosts_one: '내 작성 글',
        myPosts_other: '내 작성 글',
        savedPosts_one: '저장한 글',
        savedPosts_other: '저장한 글',
        writePost: '새 포스트 작성',

        rebalanceSuccessMsg:  "리밸런싱이 완료되었습니다. 성과는 선택하신 날짜의 장 마감 종가를 기준으로 계산되어 내일부터 반영됩니다.",

        empty: {
          feed: '아직 새로운 소식이 없습니다. 다른 사용자를 팔로우하여 소식을 받아보세요!',
          myPosts: '작성한 글이 없습니다.',
          savedPosts: '저장한 글이 없습니다.',
        },
        post: {
          likes: '좋아요 수:',
          author: '작성자:',
          unknownAuthor: '알 수 없음',
          createdAt: '작성일:',
        },
        action: {
          unsave: '저장 해제',
        },

        // 알림/오류/확인 메시지
        confirm: {
          unsavePost: '정말로 이 글을 저장 목록에서 삭제하시겠습니까?',
          deletePortfolio: '정말로 이 포트폴리오를 삭제하시겠습니까?',
          deletePost: '정말로 이 포스트를 삭제하시겠습니까?',
          unfollowUser: '{{nickname}}님을 언팔로우하시겠습니까?',
        },
        alert: {
          postUnsaved: '저장한 글 목록에서 삭제되었습니다.',
          nicknameUpdated: '닉네임이 성공적으로 수정되었습니다.',
          introductionUpdated: '금융 DNA가 성공적으로 수정되었습니다.',
          fileSizeExceeded: '파일 크기는 5MB를 초과할 수 없습니다.',
          imageFormatUnsupported: 'JPEG, PNG, WebP 포맷만 지원됩니다.',
          profileImageUpdated: '프로필 사진이 성공적으로 변경되었습니다!',
          portfolioDeleted: '포트폴리오가 삭제되었습니다.',
          postDeleted: '포스트가 삭제되었습니다.',
          followLoginRequired: '팔로우하려면 로그인해야 합니다.',
          followedUser: '{{nickname}}님을 팔로우했습니다.',
          unfollowLoginRequired: '언팔로우하려면 로그인해야 합니다.',
          unfollowedUser: '{{nickname}}님을 언팔로우했습니다.',
        },
        error: {
          feedLoad: '피드 로딩에 실패했습니다.',
          savedPostsLoad: '저장한 글 로딩에 실패했습니다.',
          unsavePostGeneric: '저장 해제에 실패했습니다:',
          profileLoad: '프로필 로딩에 실패했습니다.',
          followsLoad: '팔로우/팔로워 목록 로딩에 실패했습니다.',
          nicknameInvalid: '닉네임 형식이 올바르지 않습니다.',
          nicknameDuplicate: '이미 사용 중인 닉네임입니다.',
          noProfile: '기존 프로필이 없습니다.',
          nicknameUpdateFailed: '닉네임 변경 실패',
          introductionInvalid: '자기소개 형식이 올바르지 않습니다.',
          introductionUpdateFailed: '자기소개 변경 실패',
          introductionUpdateGeneric: '수정에 실패했습니다:',
          s3UrlFailed: '미리 서명된 URL을 가져오지 못했습니다.',
          s3UploadFailed: 'S3에 파일을 업로드하지 못했습니다.',
          profileUpdateFailed: '프로필 업데이트 실패',
          profileImageUpdateGeneric: '프로필 사진 변경에 실패했습니다:',
          portfolioLoad: '포트폴리오 로딩에 실패했습니다.',
          postsLoad: '포스트 로딩에 실패했습니다.',
          deletePortfolio: '포트폴리오 삭제에 실패했습니다:',
          deletePost: '포스트 삭제에 실패했습니다:',
          followFailed: '팔로우 실패:',
          unfollowFailed: '언팔로우 실패:',
        },
        modal: {
            // 공통 버튼
            button: {
              save: '저장',
              cancel: '취소',
            },

            // EditIntroductionModal
            intro: {
              title: '나의 금융 DNA',
              error: {
                // i18next 변수 사용: {{maxLength}}
                maxLength: '{{maxLength}}자를 초과할 수 없습니다.', 
              },
              placeholder: '예시) 거시경제 분석을 바탕으로 한 중장기 성장주 투자자입니다. IT와 바이오 섹터에 관심이 많습니다.',
            },

            // EditNicknameModal
            nickname: {
              title: '닉네임 변경',
              label: '새 닉네임:',
              error: {
                required: '닉네임을 입력해주세요.',
              },
            },

            // EditProfileImageModal
            image: {
              title: '프로필 이미지 변경',
              alert: {
                unsupportedFormat: 'JPEG, PNG, WebP 포맷만 지원됩니다.',
                // i18next 변수 사용: {{maxSizeMB}}
                sizeExceeded: '파일 크기는 {{maxSizeMB}}MB를 초과할 수 없습니다.',
              },
              placeholder: '미리보기',
            },

            // FollowListModal
            follow: {
              title: {
                following: '팔로잉 목록',
                followers: '팔로워 목록',
              },
              empty: {
                following: '아직 팔로우하는 사람이 없습니다.',
                followers: '아직 팔로워가 없습니다.',
              },
              button: {
                unfollow: '언팔로우',
                follow: '팔로우',
              },
            },
          }
      },
      backtest: {
          backtest: "백테스트",
          singleTicker: "단일 종목",
          "challengeTopOnePercent": "상위 1% 도전하기",
          "period_cut_warning_dynamic": "일부 종목의 데이터 시작일이 늦어 기간이 조정되었습니다.",
          "crisis": {
            "asiaRussia": "1998년 아시아/러시아 금융위기 (LTCM)",
            "dotcom": "2000-2002년 닷컴 버블 붕괴",
            "gfc": "2007-2009년 글로벌 금융위기 (GFC)",
            "tradeWar": "2018년 미중 무역전쟁 및 금리 인상",
            "covid": "2020년 코로나19 팬데믹 크래시",
            "inflation": "2022년 인플레이션 및 금리 인상"
          },
          "historicalCrisisCheck": "역사적 위기",
          "selectCrisisScenario": "역사적 위기 상황을 선택하세요",
          "viewFullPeriod": "전체 기간",
          error: {
            dataMissingStrict: "⚠️ {{tickers}} 종목은 선택 기간({{startDate}} ~ {{endDate}})에 데이터가 부족합니다.",
            dataMissingStrict2: "⚠️ {{tickers}} 종목은 선택 기간({{customStart}} ~ {{customEnd}})에 데이터가 부족합니다.",
            dataMissingStrict3: "⚠️ 선택 기간({{startDate}}} ~ {{endDate}})에 데이터가 부족합니다.",
            invalidCustomDate: "유효하지 않은 날짜 범위입니다.",
            checkInputsOrData:  "종목 코드가 실제 시작된 날짜를 확인해 주세요.",
            calculationFailed:  "최적화 계산 실패",
          },
          portfolio: "포트폴리오",
          backtestIntro: "내 투자 아이디어가 진짜 통할까? 과거 데이터로 미리 검증하고, 나만의 성공 투자를 설계해 보세요.",
          enterOneTickerAndWeight: "하나 이상의 종목과 비중을 입력해야 합니다.",
          enterOneTickerAndWeightForBenchmark: "하나 이상의 종목과 비중을 입력해야 합니다.(벤치마크)",
          TickerAndWeight: "종목과 비중 입력",
          weightSumMustBe100: "비중의 합은 100%여야 합니다.",
          notValidTicker: "유효하지 않은 종목 코드입니다.",
          weightPlaceholder: "비중 (%)",
          addTicker: "종목 추가",
          totalWeight: "총 비중",
          resetButton: "초기화",
          loadExamplesButton:"예시 불러오기",
          backtestPeriod: "백테스트 기간",
              "1year": "1년",
              "2years": "2년",
              "3years": "3년",
              "4years": "4년",
              "5years": "5년",
              "6years": "6년",
              "7years": "7년",
              "8years": "8년",
              "9years": "9년",
              "10years": "10년",
              "20years": "20년",
              "30years": "30년",
          custom:"입력",
          startDate:"시작일",
          endDate:"종료일",
          enterBenchmark: "벤치마크 입력",
          benchmarkExample: "예: ^GSPC, ^KS11",
          checkingTicker: "종목 확인 중...",
          runBacktest: "백테스트 실행",
          fetchErrorDetailed: "❌ 백테스트 데이터를 불러오는 중 오류 발생",
          loadingData: "데이터를 불러오는 중...",
          fetchError: "오류가 발생했습니다.",
          optimizedPortfolioError: "최적화된 포트폴리오 데이터를 찾을 수 없습니다.",
          noPortfolio: "포트폴리오가 없습니다.",
          BacktestTooltip: "툴팁 내용을 여기에 입력하세요. (예: 백테스트 데이터는 시가총액과 유동성을 고려한 가격 데이터를 기반으로 합니다.)",
          cumulativeReturn: "누적 수익률",
          vsBenchmark: "vs 벤치마크",
          individualStocks: "개별 종목",
          portfolioVsBenchmarkReturn: "포트폴리오 vs 벤치마크 수익률 변화",
          date: "날짜",
          individualStockCumulativeReturn: "개별 포트폴리오 종목 누적 수익률",
          "rebalancePeriod": "리밸런싱 주기",
          "none": "안함",
          returnAnalysis: "수익률 분석",
          daily: "일간",
          quarterly: "분기별",
          yearly: "연간",
          monthly: "월간",
          portfolioVsBenchmarkMonthlyReturn: "포트폴리오 vs 벤치마크 월별 수익률",
          individualStockMonthlyReturn: "포트폴리오 구성 종목 월별 수익률",
          portfolioVsBenchmarkYearlyReturn: "포트폴리오 vs 벤치마크 연간 수익률",
          year: "연도",
          individualStockYearlyReturn: "포트폴리오 구성 종목 연간 수익률",
          drawdown: "최대 낙폭",
          drawdownPercentage: "최대 낙폭(%)",
          portfolioVsBenchmarkMonthlyDrawdown: "포트폴리오 vs 벤치마크 월별 최대 낙폭",
          individualStockMonthlyDrawdown: "개별 포트폴리오 종목 월별 최대 낙폭",
          portfolioVsBenchmarkYearlyDrawdown: "포트폴리오 vs 벤치마크 연간 최대 낙폭",
          individualStockYearlyDrawdown: "개별 포트폴리오 종목 연간 최대 낙폭",
          Summary: "요약",
          indicator: "지표",
          optimizedPortfolio: "최적화된 포트폴리오",
          benchmark: "벤치마크",
          annualVolatility: "연간 변동성",
          maxDrawdown: "최대 낙폭",
          "sharpeRatio": "샤프 지수",
          "sharpePerformancetable": "위험(변동성) 한 단위당 얻은 초과 수익입니다. 수치가 높을수록 효율적인 투자이며, 보통 1.0 이상이면 우수, 2.0 이상이면 매우 훌륭하다고 평가합니다.",

          "calmarRatio": "칼마 지수",
          "calmarPerformancetable": "최대 낙폭(MDD) 대비 연평균 수익률입니다. 수치가 높을수록 하락장 방어력이 좋으면서 수익도 잘 낸다는 뜻이며, 보통 1.0~2.0 이상이면 매우 안정적인 전략으로 봅니다.",

          "sortinoRatio": "소르티노 지수",
          "sortinoPerformancetable": "전체 변동성이 아닌 '손실 가능성(하방 변동성)'만을 고려한 위험 대비 수익 비율입니다. 수치가 높을수록 하락장 방어력이 좋다는 뜻입니다. 보통 2.0 이상이면 매우 우수한 전략으로 평가합니다.",
          showExpertMetrics: "더보기",
          hideExpertMetrics: "숨기기",

          mutualPerformance:"비교",
          differencePB: "차이 (P-B)",
          differenceSB: "차이 (S-B)",
          
          OneYearRolling:"1년",
          ThreeYearRolling:"3년",
          FiveYearRolling:"5년",
          periodReturns: "고정 기간",
          rollingReturns: "이동 기간",
          periodDrawdown: "고정 기간",
          rollingDrawdown: "이동 기간",
          rollingDrawdownCaption: `표시된 날짜에 투자를 종료했을 때, 직전 {{activeRollingDrawdownPeriod}} 동안의 최대 낙폭입니다. (매일 리밸런싱 가정)`,
          rollingReturnCaption: `표시된 날짜에 투자를 종료했을 때, 직전 {{activeRollingPeriod}} 동안의 누적 수익률입니다. (매일 리밸런싱 가정)`,

          loadMyPortfolioButton: "내 포트폴리오",
          selectPortfolio: "포트폴리오를 선택하세요.",
          noPortfolios: "저장된 포트폴리오가 없습니다.",
          portfolioLoaded: "{{name}} 포트폴리오를 불러왔습니다. 이제 백테스트를 실행하세요.",
          portfolioLoadedSuccess: "포트폴리오 로드 완료!",
          weightSumWarning: "불러온 포트폴리오의 비중 합이 {{sum}}% 입니다. 백테스트 실행 전에 100%로 조정해 주세요.",
          savePortfolioButton: "저장",
          startTracking: "성과 추적",
          confirmResetTracking: "{{name}} 포트폴리오를 삭제하고, 현재 시점으로 성과 추적을 다시 시작하시겠습니까? (기존 추적 데이터는 삭제됩니다)",
          trackingResetSuccess: "{{name}} 포트폴리오의 등록이 완료됐습니다.",
          saveSuccess: "포트폴리오가 성공적으로 저장되었습니다.",
          benchmarkInvalidOnLoad: "불러온 벤치마크가 유효하지 않습니다. 확인 후 다시 실행해주세요.",

          portfolioAllocationHistory:"비중 변화 추이",
          
          // 💡 2. 로딩 및 버튼 관련 추가
          loading: "로딩 중",
          close: "닫기",
          private: "비공개",
          public: "공개",
          // 💡 3. 오류 메시지 세분화 (코드에 사용된 toast/error 메시지)
          loadError: {
            loginRequired: "로그인이 필요합니다.",
            fetchFailed: "포트폴리오 목록을 불러오는 데 실패했습니다.",
            emptyHoldings: "선택된 포트폴리오에 유효한 종목이 없습니다."
          },
          saveError: {
            loginRequired: "로그인이 필요합니다.",
            enterOneTickerAndWeight: "최소 하나 이상의 종목과 비중을 입력해주세요.",
            enterOneTickerAndWeightForBenchmark: "최소한 하나의 티커와 비중을 입력하십시오.(벤치마크)"
          },
          trackingResetError: {
            deleteFailed: "기존 포트폴리오 삭제 실패",
            createFailed: "새 포트폴리오 생성 실패",
            limitExceeded: "포트폴리오 생성 제한을 초과했습니다"
          },
          // 💡 4. UI/UX 및 기타 메시지
          resetMessage: "입력이 초기화되었습니다.",
          customDateRange: "커스텀 날짜 범위",
          startDate: "시작일",
          endDate: "종료일",
          shareLink: "공유 링크 복사",
          loadExampleDisclaimer: "예시가 로드되었습니다. 백테스트를 실행하세요.",
          
          // 💡 5. Toast 메시지에 필요한 키 (Modal 파일에서 사용될 수 있음)
          linkCopied: "공유 링크가 복사되었습니다.",
          newPortfolioModal: {
            loginRequiredTooltip: "포트폴리오를 저장하려면 로그인이 필요합니다."
          },
          "improveTitle": "포트폴리오 성과 개선하기",
          "improveDesc": "다양한 알고리즘과 분석 도구로 더 스마트하게 관리해보세요.",
          "allocTitle": "황금비율 찾기",
          "allocDesc": "수익을 높이는 비중 조절",
          "corrTitle": "종목 궁합 확인",
          "corrDesc": "비슷한 종목 쏠림 방지",
          "riskTitle": "손실 방패 만들기",
          "riskDesc": "하락장을 견디는 힘 측정",
          "simTitle": "투자 생존율",
          "simDesc": "가상 시나리오 미리보기",

          // 💡 추가 UI 텍스트 (초보자 친절 버전)
          "indicator": "",
          "Portfolio": "내 포트폴리오",
          "symbol": "종목명",
          "maxDrawdown": "최대 손실폭 (MDD)",
          "cumulativeReturn": "총 수익률",
          "cagr": "연평균 수익률",
          
          // 💡 전문가 모드 및 MDD 히스토리 관련
          "showExpertMetrics": "더보기",
          "hideExpertMetrics": "숨기기",
          "mddHistoryShow": "과거 큰 하락장 기록 보기",
          "mddHistoryHide": "하락장 기록 숨기기",
          "recovered": "회복 완료",
          "ongoing": "회복 중",
          "recoveryPeriod": "원금 회복 기간",
          "avgRecovery": "평균 회복 기간",
          "avgRecoveryExplanation": "전고점(Peak) 돌파 실패 시점부터 다시 전고점을 회복하기까지 걸린 평균 일수(캘린더 데이)입니다.",
          "mddPeriodExplanation": "전고점(Peak)에서 시작하여 최저점(Trough)을 지나 다시 전고점을 회복(Recovery)하기까지의 전체 기간입니다.",
          "tradingDays": "거래일",
          "avgDrawdownExplanation": "전고점 대비 하락했던 모든 구간의 평균 하락 깊이입니다. 단순 일일 변동성이 아닌 하락장의 평균적인 강도를 나타냅니다.",

          // 💡 성과 지표 상세 설명 (초보자용 툴팁)
          "winRate": "승률 (Win Rate)",
          "winRateExplanation": "투자 기간 중 수익으로 마감한 날의 비율입니다. 수치가 높을수록 꾸준히 수익을 냈다는 뜻입니다.",
          
          "profitFactor": "수익 대비 손실비 (PF)",
          "profitFactorExplanation": "번 돈이 잃은 돈보다 얼마나 많은지 보여줍니다. 1.0보다 크면 이익을 보고 있다는 의미이며, 보통 1.5 이상이면 우수한 전략으로 평가합니다.",
          
          "ulcer": "고통 지수 (Ulcer Index)",
          "ulcerExplanation": "하락의 깊이와 회복 기간을 합산해 투자자의 심리적 고통을 수치화한 지표입니다. 낮을수록 좋으며 보통 5 이하는 매우 안정적, 15 이상은 큰 인내심이 필요한 위험 구간으로 봅니다.",

          "upi": "스트레스 대비 효율 (UPI)",
          "upiExplanation": "고통 지수(Ulcer) 대비 수익이 얼마나 알찬지 나타냅니다. 수치가 높을수록 고생 대비 보상이 크다는 뜻이며, 보통 1.0 이상이면 효율적, 2.0 이상이면 매우 우수한 전략으로 평가합니다.",
                
          "avgDrawdown": "평균 하락폭",
          "avgDrawdownExplanation": "전고점 대비 발생한 개별 낙폭들의 평균값입니다. 하락 발생 시 자산이 보통 어느 정도까지 후퇴하는지 그 방어력을 측정합니다.",
          
          "strategy": "내 포트폴리오",
          "benchmark": "벤치마크", // 변수 삽입 포함
          "profitabilitySummary": "성과",
          "riskManagement": "위험",
          "diversificationRatio": "분산 효율 점수 (DR)",
          // "diversificationExplanation": "높을수록 좋습니다. 자산 간 상관관계를 낮춰 위험을 얼마나 잘 분산했는지 보여줍니다. (1.2 이상 우수)",
          "diversificationExplanation": "분산 투자 효율성 지표입니다. [1.0: 없음 | 1.1~1.2: 보통 | 1.2~1.5: 우수 | 1.6~: 강력]",
          "collapse": "접기 ▲",
          "history": "히스토리 ▼",
          "var95": "일간 예상 손실 (VaR 95%)",
          "varExplanation": "VaR (95%): 정상적인 시장에서 95% 확률로 발생 가능한 최대 손실폭입니다. (상위 5%의 극단적 위험 제외)",
          "efficiency": "효율성",
          "expertViewLess": "🔍 하락장 방어/회복력 ▲",
          "expertViewMore": "🔍 하락장 방어/회복력 ▼",
          "chart": "차트",
          "table": "표",
          

        }
    }
  }
};

i18n
  .use(LanguageDetector) 
  .use(initReactI18next)
  .init({
    resources,
    detection: { // 👈 추가
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    // lng: 'ko', 
    fallbackLng: 'en', // 번역이 없을 때 대체 언어
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;